import { constants } from 'node:buffer';
import * as C from './constants.js';
import { start } from 'node:repl';

let connectionInfo = {
  logged_in : false
  , uid : C.UID_WHEN_LOGGED_OUT
  // , login_date : new Date()
  // , login_expires : new Date()
  , app_init_complete : false
  , devMode : false
  , bypassLoginScreen : false // auto log in as dev
  , bypassLoginScreenUser : ""
  , bypassLoginPW : ""
  , hostName : 'https://www.defconradar.com/'
};



// Input options. Same will be static and some will be dynamic
let opts = {
    storeList : []
  , saleTypes : ['All', 'New', 'Used', 'Wholesale', 'F&I']
  , vseSlsPeople : []
  , vseFIPeople : []
  , cddEmpIds : []
  , salesDeptList : ['General Merchandise', 'Parts OTC', 'Service', 'Online', 'Technician']
  , allDepartments : ["Accounting" , "General Merchandise" , "Parts OTC" , "Vehicle" , "Service" , "CIT" , "F&I" , "Payroll" , "Online" , "Technician" ]
  , otbMTDStatuses : ['Ongoing', 'Complete']
  , otbCategories : ["A1 - Hats/Caps - Men" , "A2 - Hats/Caps - Women" , "A5 - Small Accessories - Men" , "A6 - Small Accessories - Women" , "AC - Aftermarket Clothing" , "AE - Aftermarket Eyewear" , "AG - Aftermarket GM" , "AR - Aftermarket Helmets" , "AW - Taxed Headwraps" , "BK - Buckles" , "BN - Belts - NonTaxable" , "D1 - Denim - Men" , "D2 - Denim - Women" , "E1 - eComm LP Men" , "E2 - eComm LP Women" , "G1 - Hardgoods/Homegoods" , "GX - Miscellaneous GM" , "HR - Rain Gear" , "L1 - Leather - Men" , "L2 - Leather - Women" , "L3 - Leather - Taxable" , "L4 - Leather - NonTaxable" , "LB - LP - Bed Bath" , "LE - Eyewear" , "LF - Footwear" , "LH - LP - Hats" , "LJ - Jewelry" , "LK - Kids Nontaxed" , "LN - Kids Taxed" , "LP - Licensed Products Custom" , "LR - LP - Purses" , "LS - Belts" , "LT - Vehicle Products" , "LW - LP - Wallets" , "O1 - Casual Outerwear - Men" , "O2 - Casual Outerwear - Women" , "R0 - Functional - Women" , "R1 - Gloves - Men" , "R2 - Gloves - Women" , "R3 - Helmets - Men" , "R4 - Helmet - Women" , "R5 - Tax Aftermarket Riding Gear" , "R6 - Non-tax Aftermarket Riding Gear" , "R7 - Heated/Cold Weather " , "R8 - RG Heated/Cold Weather - Women" , "R9 - Functional - Men" , "S1 - Sportswear - Men" , "S2 - Sportswear - Women" , "SA - STACYC" , "T0 - Men's Tanks" , "T1 - Men's Short Sleeve" , "T2 - Men's Long Sleeve" , "T3 - Men's Sweatshirts" , "T4 - Men's Pocket T's" , "T5 - Men's Henly" , "T6 - Women's Tanks" , "T7 - Women's Short Sleeve" , "T8 - Women's Long Sleeve" , "T9 - Women's Sweatshirt" , "TS - Tshirts" ]
  , otbCategoriesByStore : []
  , otbGroups : ["AM - Small Accessories - Men's", "AW - Small Accessories - Women's", "BT - Boots", "CM - Hats/Caps - Men's", "CW - Hats/Caps - Women's", "DM - Denim - Men's", "DW - Denim - Women's", "EY - Eyewear, Goggles, Sunglasses", "FM - Functional Outwear - Men's", "FW - Functional Outwear - Women's", "GV - Gloves - Men's", "GW - Gloves - Women's", "HE - Helmet's - Men's", "HR - Rainwear", "HW - Helmet's - Women's", "JY - Jewelry", "LK - Licensed Products Kids", "LM - Leather - Men's", "LP - Licensed Products", "LW - Leather - Women's", "OM - Casual Outerwear - Men's", "OP - Other Products - GM", "OW - Casual Outerwear - Women's", "R3 - Collectables/Home Goods", "R7 - Buell GM", "R9 - R9", "SM - Sportswear - Men's", "SW - Sportswear - Women's", "T0 - Men's Tanks", "T1 - Men's Short Sleeve", "T2 - Men's Long Sleeve", "T3 - Men's Sweatshirts", "T4 - Men's Pocket T's", "T5 - Men's Henly", "T6 - Women's Tanks", "T7 - Women's Short Sleeve", "T8 - Women's Long Sleeve", "T9 - Women's Sweatshirt", "TS - All T Categories", "VP - LP - Vehicle Accessories", "WM - Heated/Cold Weather", "WW - Heated/Cold Weather - Women's" ]
  , otbBatchProjFields : [C.OTB_DISPLAY_FIELD_FUTURE_ORDER_EXPECTED, C.OTB_DISPLAY_FIELD_PROJECTED_INCREASE, C.OTB_DISPLAY_FIELD_PROJECTED_MARGIN, C.OTB_DISPLAY_FIELD_PROJECTED_TURNS, C.OTB_DISPLAY_FIELD_PROJECTED_SALES_OVERRIDE, C.OTB_DISPLAY_FIELD_PROJECTED_COGS_OVERRIDE]
  , otbBatchProjFieldsDisplayNames : [{ 
      field: C.OTB_FIELD_FUTURE_ORDER_EXPECTED, display_name: C.OTB_DISPLAY_FIELD_FUTURE_ORDER_EXPECTED, number_format: C.CURRENCY_FORMAT }, { 
      field: C.OTB_FIELD_PROJECTED_INCREASE, display_name: C.OTB_DISPLAY_FIELD_PROJECTED_INCREASE, number_format: C.CURRENCY_FORMAT }, { 
      field: C.OTB_FIELD_PROJECTED_MARGIN, display_name: C.OTB_DISPLAY_FIELD_PROJECTED_MARGIN, number_format: C.PERCENT_FORMAT }, { 
      field: C.OTB_FIELD_PROJECTED_TURNS, display_name: C.OTB_DISPLAY_FIELD_PROJECTED_TURNS, number_format: C.NUMBER_FORMAT }, { 
      field: C.OTB_FIELD_PROJECTED_SALES_OVERRIDE, display_name: C.OTB_DISPLAY_FIELD_PROJECTED_SALES_OVERRIDE, number_format: C.CURRENCY_FORMAT }, { 
      field: C.OTB_FIELD_PROJECTED_COGS_OVERRIDE, display_name: C.OTB_DISPLAY_FIELD_PROJECTED_COGS_OVERRIDE, number_format: C.CURRENCY_FORMAT }]  
  , dateDefaultStart : "2024-03-01" //dev
  , dateDefaultEnd : "2024-03-31" //dev
  , dateDefaultMonth: "2024-03"
  , storeLookup : {
     1 :	"2842"
    , 2 :	"3919"
    , 3 :	"3918"
    , 6 :	"4200"
    , 7 :	"4428"
    , 8 :	"4429"
    , 9 :	"5044"
  }  
  , departmentList : []
  // , vseSlsPeopleByStore : []
  // , allFiPeople : [
  //     ["2842", "AAA"], // Row 0
  //     ["2842", "BBB"], // Row 1
  //     ["2842", "CCC"]  // Row 2
  //   ]
  , umUserList : []   
  , umLoadedUserInfo : []
  , umLoadedUserAssignedDepts : []
};

if(!connectionInfo.devMode) {
  let dateToday = new Date();
  opts["dateDefaultStart"] = new Date(dateToday.getFullYear(), dateToday.getMonth(), 1).toISOString().split('T')[0]; // Get first of month date in YYYY-MM-DD format
  opts["dateDefaultEnd"] = dateToday.toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

  opts["dateDefaultMonth"] = opts["dateDefaultEnd"].substring(0, 7);
};

    
Office.onReady((info) => {
  if(connectionInfo.app_init_complete === true) { // should not occur
    updateFooterStatus(`${new Date().toLocaleTimeString()} - onReady "But like, it didn't need be called. Why was it?`);

  } else if(isLoggedIn()) { // should not occur
    updateFooterStatus(`${new Date().toLocaleTimeString()} - onReady Logged in while inititializing!? User: ${connectionInfo.uid}, logged_in:${connectionInfo.logged_in}`);

  } else { // should happen
    updateFooterStatus(`${new Date().toLocaleTimeString()} - Initiating app...`);

    // Set the UI to the default values
    hideAllTaskpaneDivs();
    
    // Tie HTML elements to functions
    attachElementsToFunctions();

    // Assign dynamic options to HTML input elements
    setHMTLInputOptionsAndDefaults();
    
    // Show the add-in
    document.getElementById("app-body").style.display = "flex";

    // if(connectionInfo.bypassLoginScreen) {
    //   updateFooterStatus(`${new Date().toLocaleTimeString()} - Dev Mode - Bypassing login screen`)
    //   tryToLogIn(connectionInfo.bypassLoginScreenUser, connectionInfo.bypassLoginPW);
    // } else {
    //   // navLoginScreen();
    // }
    
    navTo(C.NAV_LOGIN)
    connectionInfo.app_init_complete = true;
    updateFooterStatus(`${new Date().toLocaleTimeString()} - Radar locked and loaded`);

  }
});

/** Default helper for invoking an action and handling errors. */
async function tryCatch(callback) {
    try {
        await callback();
    } catch (error) {
        // Note: In a production add-in, you'd want to notify the user through your add-in's UI.
        console.error(`Error: ${error}`);
        updateFooterStatus(`Error: ${error}`);
    }
}

function attachElementsToFunctions() {
    // Tie HTML elements to functions
    
    
    document.getElementById("um-load-users").onclick = () => tryCatch  (loadUserManagement);    
    document.getElementById("um-save-user").onclick = () => tryCatch  (updateUserAccount);    

    document.getElementById("dash-refresh-dashboard").onclick = () => tryCatch  (loadDashboard);    

    document.getElementById("nav-showhide-nav-box").onclick = () => tryCatch (showHideNavPanel);        
    document.getElementById("login-button-login").onclick = () => tryCatch  (btnLoginOnClick);        
    document.getElementById("nav-user-mgmt").onclick = () => tryCatch(() => navTo(C.NAV_UM)); // User management - view and edit active (and/or inactive) Radar users, add new users and set store/department-specific permissions.
    document.getElementById("nav-emp-mgmt").onclick = () => tryCatch(() => navTo(C.NAV_EM)); // Manage Defon employees for use in various reports
    document.getElementById("nav-vs-unit-doc-entry").onclick = () => tryCatch(() => navTo(C.NAV_VS_ENTRY)); // Vehicle Sales Main - load existing sales into Excel, and add new/edit existing sales in the taskpane
    document.getElementById("nav-vs-unit-add").onclick = () => tryCatch(() => navTo(C.NAV_VS_ENTRY_ADD));  // Vehicle Sales - jump to creating a new sale
    document.getElementById("nav-vs-manager-report").onclick = () => tryCatch(() => navTo(C.NAV_VS_MGR)); // Vehicle Sales Manager Report - view and filter the manager report
    document.getElementById("nav-vgpd-report").onclick = () => tryCatch(() => navTo(C.NAV_VS_GPD)); // Vehicle Sales GP Details Report - view and filter the GP details report
    document.getElementById("nav-vsl-report").onclick = () => tryCatch(() => navTo(C.NAV_VS_LEADERBOARD)); // Vehicle Sales Leaderboard - view and filter the sales leaderboard report
    document.getElementById("nav-fi-leaderboard").onclick = () => tryCatch(() => navTo(C.NAV_FI_LEADERBOARD)); // F&I Leaderboard - view and filter the F&I leaderboard report
    document.getElementById("nav-daily-sales").onclick = () => tryCatch(() => navTo(C.NAV_DAILY_SALES)); // Daily Sales Update for everything but vehicle sales (GM, parts, etc.)
    document.getElementById("nav-sales-leaderboard").onclick = () => tryCatch(() => navTo(C.NAV_DAILY_SALES_LEADERBOARD)); // Daily Sales Leaderboard - view and filter the daily sales leaderboard for non-vehicle departments
    document.getElementById("nav-cit").onclick = () => tryCatch(() => navTo(C.NAV_CIT)); // CIT Report - view and filter the CIT report, and edit CIT fields in the taskpane
    document.getElementById("nav-commission-payroll").onclick = () => tryCatch(() => navTo(C.NAV_COM_PAYROLL));
    document.getElementById("nav-commission-drilldown").onclick = () => tryCatch(() => navTo(C.NAV_COM_DRILLDOWN));
    document.getElementById("nav-login-screen").onclick = () => tryCatch(() => navTo(C.NAV_LOGIN));
    
    document.getElementById("nav-loaded-settings").onclick = () => tryCatch(showLoadedVariables);
    document.getElementById("nav-refresh-settings").onclick = () => tryCatch(refreshLoadedVariables);        

    document.getElementById("nav-otb-gm-mtd-entry").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_MTD));
    document.getElementById("nav-otb-gm-batch-entry").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_BATCH));
    document.getElementById("nav-otb-gm-defcon-recap").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_RECAP));
    document.getElementById("nav-otb-gm-cagtegory").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_CAT ));
    document.getElementById("nav-otb-gm-group").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_GROUP));
    document.getElementById("nav-otb-gm-summary").onclick = () => tryCatch(() => navTo(C.NAV_OTB_GM_SUMMARY));
      
    document.getElementById("nav-dashboard").onclick = () => tryCatch(() => navTo(C.NAV_DASHBOARD));
    document.getElementById("lvs-load-sales").onclick = () => tryCatch(loadVehicleSales);
    document.getElementById("lvs-edit-sale").onclick = () => tryCatch(editSelectedSale);

    document.getElementById("load-vs-manager-report").onclick = () => tryCatch(loadVehicleManagerReport);
    document.getElementById("load-vgpd-report").onclick = () => tryCatch(loadVehicleGPReport);
    document.getElementById("load-vsl-report").onclick = () => tryCatch(loadVehicleSalesLeaderboard);
    document.getElementById("load-fil-report").onclick = () => tryCatch(loadFILeaderboard);
    document.getElementById("load-cit-report").onclick = () => tryCatch(loadCIT);
    document.getElementById("edit-cit-selected").onclick = () => tryCatch(editCITSale);
    
    document.getElementById("load-dsu-report").onclick = () => tryCatch(loadDailySalesReport);
    document.getElementById("submit-dsu-report").onclick = () => tryCatch(saveDailySalesReport);

    document.getElementById("load-dsl-report").onclick = () => tryCatch(loadDailySalesLeaderboard);    
    
    document.getElementById("vse-btn-tab-vi").onclick = () => tryCatch(openVSETabVI);
    document.getElementById("vse-btn-tab-fi").onclick = () => tryCatch(openVSETabFI);
    document.getElementById("vse-btn-submit").onclick = () => tryCatch(addOrUpdateVehicleSale);
    document.getElementById("vse-btn-clear-form").onclick = () => tryCatch(clearVehicleSaleForm);

    document.getElementById("com-load-report").onclick = () => tryCatch(loadCommissionReport);
    document.getElementById("cdd-load-report").onclick = () => tryCatch(loadCommissionDrilldownReport);

    document.getElementById("otb-gm-mtd-load-report").onclick = () => tryCatch(loadOTBGMMTDReport);
    document.getElementById("otb-gm-mtd-save").onclick = () => tryCatch(saveOTBGMMTDReport);
    
    document.getElementById("otb-gm-batch-load-report").onclick = () => tryCatch(loadOTBGMBatchReport);
    document.getElementById("otb-gm-batch-save").onclick = () => tryCatch(saveOTBGMBatchReport);
    
    document.getElementById("otb-gm-recap-load-report").onclick = () => tryCatch(loadOTBGMRecapReport);
    
    document.getElementById("otb-gm-cat-load-report").onclick = () => tryCatch(loadOTBGMCategoryReport);
    document.getElementById("otb-gm-cat-save").onclick = () => tryCatch(saveOTBGMCategoryReport);
    
    document.getElementById("otb-gm-group-load-report").onclick = () => tryCatch(loadOTBGMGroupReport);
    
    document.getElementById("otb-gm-sum-load-report").onclick = () => tryCatch(loadOTBGMSummaryReport);
}

function setHMTLInputOptionsAndDefaults() {
    //User management
    // document.getElementById("um-dept").innerHTML = allDepartments.map(dept => `<option value="${dept}">${dept}</option>`).join("");
    document.getElementById("um-reg-date").value = '';//opts["dateDefaultEnd"]; 
    populateUMDepartmentInputs(); // Create/recreate the checkboxes for store depts

    //Vehicle Sales LIst
    document.getElementById("lvs-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("lvs-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("lvs-date-end").value = opts["dateDefaultEnd"];

    //Vehicle Sale Entry
    document.getElementById("vse-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("vse-date").value = opts["dateDefaultEnd"];
    document.getElementById("vse-salesperson-1").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
    document.getElementById("vse-salesperson-2").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");    
    document.getElementById("vse-fi-id").innerHTML = opts["vseFIPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");    

    //Vehicle Sale Manager Report
    document.getElementById("vsm-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("vsm-date-end").value = opts["dateDefaultEnd"];

    //Vehicle Sale GP Details Report
    document.getElementById("vgpd-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("vgpd-date-end").value = opts["dateDefaultEnd"];
    document.getElementById("vgpd-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("vgpd-type").innerHTML = opts["saleTypes"].map(sale_type => `<option value="${sale_type}">${sale_type}</option>`).join("");

    //Vehicle Sales Leaderboard Report
    document.getElementById("vsl-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("vsl-date-end").value = opts["dateDefaultEnd"]; 

    //F&I Leaderboard Report
    document.getElementById("fil-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("fil-date-end").value = opts["dateDefaultEnd"]; 

    //Daily Sales Update
    //store date  dept
    document.getElementById("dsu-date").value = opts["dateDefaultEnd"]; 
    document.getElementById("dsu-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("dsu-dept").innerHTML = opts["salesDeptList"].map(dept => `<option value="${dept}">${dept}</option>`).join("");
    

    //Daily Sales Leaderboard
    document.getElementById("dsl-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("dsl-date-end").value = opts["dateDefaultEnd"]; 
    document.getElementById("dsl-dept").innerHTML = opts["salesDeptList"].map(dept => `<option value="${dept}">${dept}</option>`).join("");

    //CIT
    //start end store dataset inc_inc inc_comp
    document.getElementById("cit-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("cit-date-end").value = opts["dateDefaultEnd"]; 
    document.getElementById("cit-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");

    //Commission Payroll
    //start end store
    document.getElementById("com-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("com-date-end").value = opts["dateDefaultEnd"]; 
    document.getElementById("com-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");

    //Commission Drilldown 
    //start end store salesperson AND sales_id --- whyyy
    //print / save to pdf
    document.getElementById("cdd-date-start").value = opts["dateDefaultStart"]; 
    document.getElementById("cdd-date-end").value = opts["dateDefaultEnd"]; 
    document.getElementById("cdd-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("cdd-emp-id").innerHTML = opts["cddEmpIds"].map(emp => `<option value="${emp}">${emp}</option>`).join("");

    // OTB - GM - MTD Data Entry
    document.getElementById("otb-gm-mtd-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-mtd-date").value = opts["dateDefaultMonth"]; 
    document.getElementById("otb-gm-mtd-status").innerHTML = opts["otbMTDStatuses"].map(stat => `<option value="${stat}">${stat}</option>`).join("");
    
    // // OTB - GM - Batch Entry
    document.getElementById("otb-gm-batch-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-batch-date").value = opts["dateDefaultMonth"]; 
    document.getElementById("otb-gm-batch-proj-field").innerHTML = opts["otbBatchProjFields"].map(stat => `<option value="${stat}">${stat}</option>`).join("");
    
    // // OTB - GM - Recap
    document.getElementById("otb-gm-recap-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-recap-date").value = opts["dateDefaultMonth"]; 
    
    // // OTB - GM - Cat Entry
    document.getElementById("otb-gm-cat-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-cat-date").value = opts["dateDefaultMonth"]; 
    // document.getElementById("otb-gm-cat-category").innerHTML = opts["otbCategories"].map(cat => `<option value="${cat}">${cat}</option>`).join(""); //THIS IS THE GOOd, BASIC NONDYNAMIC VERSION
    updateOTBGMCatCategoryList(); // sets otb-gm-cat-category dropdown based on the default store

    // // OTB - GM - Group Entry
    document.getElementById("otb-gm-group-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-group-date").value = opts["dateDefaultMonth"]; 
    // document.getElementById("otb-gm-group-group").innerHTML = opts["otbGroups"].map(grp => `<option value="${grp}">${grp}</option>`).join("");
    updateOTBGMCatGroupList(); // sets otb-gm-cat-group dropdown based on the default store
    

    // // OTB - GM - Summary
    document.getElementById("otb-gm-sum-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
    document.getElementById("otb-gm-sum-date").value = opts["dateDefaultMonth"]; 
    

    //Add Event Listeners to each relevant report

    // Login
    document.getElementById("login-password").addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        tryCatch(btnLoginOnClick);
      }
    });

    // User Management
    document.getElementById("um-user-select").addEventListener("change", function (event) {
        loadUMUserInfoIfNoUnsavedChanges();        // check before updating loaded user
    });    


    //Vehicle Sales Entry
    document.getElementById("vse-vehicle-gp-base").addEventListener("change", function (event) {
      updateVSEFinalGP();        
    });
    document.getElementById("vse-less-dpp").addEventListener("change", function (event) {
      updateVSEFinalGP();        
    });
    document.getElementById("vse-less-fees").addEventListener("change", function (event) {
      updateVSEFinalGP();        
    });
    document.getElementById("vse-add-hd-promo").addEventListener("change", function (event) {
      updateVSEFinalGP();        
    });

    document.getElementById("vse-gp-vip").addEventListener("change", function (event) {
      updateVSEFinalFIGP();        
    });
    document.getElementById("vse-gp-esp").addEventListener("change", function (event) {
      updateVSEFinalFIGP();        
    });
    document.getElementById("vse-gp-gap").addEventListener("change", function (event) {
      updateVSEFinalFIGP();        
    });
    document.getElementById("vse-gp-tw").addEventListener("change", function (event) {
      updateVSEFinalFIGP();        
    });
    document.getElementById("vse-gp-other").addEventListener("change", function (event) {
      updateVSEFinalFIGP();        
    });



    // Daily Sales Update/Leadeboard
    document.getElementById("dsu-sales-daily-total").addEventListener("change", function(event) { 
      updateDSUSalesTotals();
    });

    document.getElementById("dsu-sales-daily-ass").addEventListener("change", function(event) {
      updateDSUSalesTotals(); //this will essentially be a secondary event as we'll update this field when the sheet changes. That will be async, this doesn't need to be.
    });


    document.getElementById("otb-gm-cat-store").addEventListener("change", function (event) {
      updateOTBGMCatCategoryList();        
    });


//     const dropdown = document.querySelector('select');
// dropdown.addEventListener('change', (event) => {
//   console.log("Selected value:", event.target.value);
// });
}



async function setAsyncEventListeners() {
  await Excel.run(async (context) => {
    // Add any event listeners that require async operations due to Excel interactions here

    // DSU
    let wsDSU = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_DAILY_SALES);
    // const table = sheet.tables.getItem("MyTableName");

    wsDSU.onChanged.add(onDSUTableChange);

    console.log("Event listener registered successfully.");
    await context.sync();
  });  
}

function isLoggedIn() {
  // Returns true if any user is currently logged in
  return connectionInfo.logged_in === true; // easy.
}

async function updateVSEFinalGP() {
    await Excel.run(async (context) => {
      const gpBase = Number(document.getElementById("vse-vehicle-gp-base").value);
      const gpDPP = Number(document.getElementById("vse-less-dpp").value);
      const gpFees =  Number(document.getElementById("vse-less-fees").value);
      const gpHDPromo = Number(document.getElementById("vse-add-hd-promo").value);
      document.getElementById("vse-final-gp").value = gpBase - gpDPP - gpFees + gpHDPromo;
  });
}
async function updateVSEFinalFIGP() {
    await Excel.run(async (context) => {
      const vip = Number(document.getElementById("vse-gp-vip")?.value ?? 0);
      const esp = Number(document.getElementById("vse-gp-esp")?.value ?? 0);
      const gap =  Number(document.getElementById("vse-gp-gap")?.value ?? 0);
      const tw = Number(document.getElementById("vse-gp-tw")?.value ?? 0);
      const other = Number(document.getElementById("vse-gp-other")?.value ?? 0);
      const finalGpElement = document.getElementById("vse-fi-final-gp");
      if (finalGpElement) {
        finalGpElement.value = vip + esp + gap + tw + other;
      }
  });
}



function unsavedChangesExistInVSE() {
  //Returns true if any of the fields in the VSE are not blank (ignoring dropdown values)
  updateFooterStatus('TO DO check if unsavedChangesExistInVSE')
  return true; 
  
}

async function navTo(destName) {
  await Excel.run(async (context) => {
    hideAllTaskpaneDivs();
    let ws;
    // document.getElementById("vehicle-sales-entry-form").style.display = "grid";
    // document.getElementById("vse-store").focus();

    switch (destName) {
      case C.NAV_UM:
        document.getElementById("user-mgmt").style.display = "grid";        
        break;

      case C.NAV_EM: 
        document.getElementById("emp-mgmt").style.display = "grid";
        break;

      case C.NAV_VS_ENTRY:
        
        document.getElementById("load-vehicle-sales-form").style.display = "grid";
        document.getElementById("lvs-store").focus();

        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_VS_ENTRY);
        ws.load("isNullObject");
        await context.sync();
        if(ws.isNullObject) {
          addRadarSheet(context, C.SHEET_NAME_VS_ENTRY, C.COLOR_HEADER_VS_ENTRY, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_ENTRY);
        }
        ws.activate();
        await context.sync();        
        break;
      
      case C.NAV_VS_ENTRY_ADD:
        openVSETabVI(); //Select the first tab by default
        
        //if not empty, prompt user if they want to continue
        if(unsavedChangesExistInVSE()) {

        }
        document.getElementById("vehicle-sales-entry-form").style.display = "grid";
        document.getElementById("vse-store").focus();
      break;
    
      case C.NAV_VS_MGR:
        document.getElementById("vehicle-sales-manager-report-form").style.display = "grid";
        document.getElementById("vsm-date-start").focus();
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_MGR_REPORT);
        ws.activate();
        break;
      
      case C.NAV_VS_GPD:
        document.getElementById("vehicle-sales-gp-details-form").style.display = "grid";
        document.getElementById("vgpd-date-start").focus();
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_GP_DETAILS);
        ws.activate();
        break;
      
      case C.NAV_VS_LEADERBOARD: 
        document.getElementById("vehicle-sales-leaderboard-form").style.display = "grid";
        document.getElementById("vsl-date-start").focus();
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_LEADERBOARD);
        ws.activate();
        break;
      
      case C.NAV_FI_LEADERBOARD:
        document.getElementById("fi-leaderboard-form").style.display = "grid";
        document.getElementById("fil-date-start").focus();      
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_FI_LEADERBOARD);
        ws.activate();
        break;
      
      case C.NAV_DAILY_SALES:
        document.getElementById("daily-sales-form").style.display = "grid";
        document.getElementById("dsu-date").focus();
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_DAILY_SALES);
        ws.activate();
        break;
      
      case C.NAV_DAILY_SALES_LEADERBOARD:
          document.getElementById("daily-sales-leaderboard-form").style.display = "grid";
          document.getElementById("dsl-date-start").focus();
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_LEADERBOARD);
          ws.activate();
        
        break;
      
      case C.NAV_CIT:
        document.getElementById("cit-form").style.display = "grid";
        document.getElementById("cit-date-start").focus();  
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_CIT);
        ws.activate();
          
        break;
      
      case C.NAV_COM_PAYROLL:
        document.getElementById("com-payroll-form").style.display = "grid";
        document.getElementById("com-date-start").focus();  
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_COMMISSION_PAYROLL);
        ws.activate();
        break;
      
      case C.NAV_COM_DRILLDOWN:
        document.getElementById("cdd-form").style.display = "grid";
        document.getElementById("cdd-date-start").focus();  
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_COMMISSION_DRILLDOWN);
        ws.activate();        
        break;
      
      case C.NAV_LOGIN:
        if(connectionInfo.logged_in) {
          logOut();
        
        } else { 
          hideAllTaskpaneDivs();
          document.getElementById("login-screen").style.display = "grid";
          document.getElementById("login-user").focus();
        }
        break;

      case C.NAV_OTB_GM_MTD:
        document.getElementById("otb-gm-mtd-form").style.display = "grid";
        document.getElementById("otb-gm-mtd-store").focus();

        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_MTD_ENTRY);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_MTD_ENTRY, C.SHEET_HEADER_OTB_GM_MTD_ENTRY, C.COLOR_HEADER_OTB_GM_MTD_ENTRY, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_MTD_ENTRY);
        }
        ws.activate();
        await context.sync();
        break;

      case C.NAV_OTB_GM_BATCH:
        hideAllTaskpaneDivs();
        document.getElementById("otb-gm-batch-form").style.display = "grid";
        document.getElementById("otb-gm-batch-store").focus();


        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_BATCH_ENTRY);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_BATCH_ENTRY, C.SHEET_HEADER_OTB_GM_BATCH_ENTRY, C.COLOR_HEADER_OTB_GM_BATCH_ENTRY, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_BATCH_ENTRY);
        }

        ws.activate();
        await context.sync();        
        break;

      case C.NAV_OTB_GM_RECAP:
        document.getElementById("otb-gm-recap-form").style.display = "grid";
        document.getElementById("otb-gm-recap-store").focus();


        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_RECAP);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_RECAP, C.SHEET_HEADER_OTB_GM_RECAP, C.COLOR_HEADER_OTB_GM_RECAP, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_RECAP);
        }

        ws.activate();
        await context.sync();
        break;

      case C.NAV_OTB_GM_CAT:
        document.getElementById("otb-gm-cat-form").style.display = "grid";
        document.getElementById("otb-gm-cat-store").focus();
        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_CATEGORY);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_CATEGORY, C.SHEET_HEADER_OTB_GM_CATEGORY, C.COLOR_HEADER_OTB_GM_CATEGORY, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_CATEGORY);
        }

        ws.activate();
        await context.sync();        
        break;

      case C.NAV_OTB_GM_GROUP:
        document.getElementById("otb-gm-group-form").style.display = "grid";
        document.getElementById("otb-gm-group-store").focus();


        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_GROUP);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_GROUP, C.SHEET_HEADER_OTB_GM_GROUP, C.COLOR_HEADER_OTB_GM_GROUP, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_GROUP);
        }

        ws.activate();
        await context.sync();        
        break;

      case C.NAV_OTB_GM_SUMMARY:
        document.getElementById("otb-gm-sum-form").style.display = "grid";
        document.getElementById("otb-gm-sum-store").focus();


        ws = context.workbook.worksheets.getItemOrNullObject(C.SHEET_NAME_OTB_GM_SUMMARY);
        ws.load("isNullObject");
        await context.sync();

        if(ws.isNullObject) {
          addRadarSheet(C.SHEET_NAME_OTB_GM_SUMMARY, C.SHEET_HEADER_OTB_GM_SUMMARY, C.COLOR_HEADER_OTB_GM_SUMMARY, "todo");
          ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_SUMMARY);
        }

        ws.activate();
        await context.sync();        
        break;
      case C.NAV_DASHBOARD:

        document.getElementById("dashboard-tab").style.display = "grid";
        document.getElementById("dash-refresh-dashboard").focus();
        ws = context.workbook.worksheets.getItem(C.SHEET_NAME_HOME);
        // const dashMainTitle = "DEFCON 3 - Breathe Easier";
        // ws.getRange("A1").values = [[dashMainTitle]];  // TODO magic number
        ws.activate();
        await context.sync();   
        break;

    }

  });
}

//

async function showHideNavPanel() {
  await Excel.run(async (context) => {
    let divNavPanel = document.getElementById('defcon-navigation');
    if (divNavPanel.style.display !== "none") {
      divNavPanel.style.display = "none";
    } else {
      divNavPanel.style.display = "grid";

    }
  });
}


async function showLoadedVariables() {
  await Excel.run(async (context) => {
    // await clearSheet(context, C.SHEET_NAME_LOADED_VARIABLES);


    let app = context.workbook.application;
    // app.suspendScreenUpdatingUntilNextSync();
    
    const ws = context.workbook.worksheets.add();

    ws.getRange("A1").values = [["DEFCON Settings"]];
    ws.getRange("A2").values = [["Last Updated at"]];
    ws.getRange("B2").values = [["a timestamp"]];
    
    ws.getRange("A4").values = [["storeList"]];
    ws.getRange("A5").getResizedRange(0, opts["storeList"].length -1).values = [opts["storeList"]];
   
    ws.getRange("A7").values = [["saleTypes"]];
    ws.getRange("A8").getResizedRange(0, opts["saleTypes"].length -1).values = [opts["saleTypes"]];
   
    ws.getRange("A10").values = [["salesDeptList"]];
    ws.getRange("A11").getResizedRange(0, opts["salesDeptList"].length -1).values = [opts["salesDeptList"]];
   
    ws.getRange("A13").values = [["vseSlsPeople"]];
    ws.getRange("A14").getResizedRange(0, opts["vseSlsPeople"].length -1).values = [opts["vseSlsPeople"]];
    
    ws.getRange("A16").values = [["vseFIPeople"]];
    ws.getRange("A17").getResizedRange(0, opts["vseFIPeople"].length -1).values = [opts["vseFIPeople"]];
    
    // ws.getRange("A19").values = [["departmentList"]];
    // ws.getRange("A20").getResizedRange(0, opts["departmentList"].length -1).values = [opts["departmentList"]];
    ws.activate();
    await context.sync();
   

  });
}

async function clearLoadedVariables() {
  await Excel.run(async (context) => {
    
    opts.storeList = [];
    opts.vseSlsPeople = [];
    opts.vseFIPeople = [];
    opts.cddEmpIds = [];
    opts.otbCategories = [];
    opts.otbCategoriesByStore = [];
    opts.otbGroups = [];
    opts.departmentList = [];
    opts.umUserList = [];
    opts.umLoadedUserInfo = [];
    opts.umLoadedUserAssignedDepts = [];

    
    // setHMTLInputOptionsAndDefaults();
  });
}


async function refreshLoadedVariables() {
  await Excel.run(async (context) => {
    // await clearSheet(context);

    let app = context.workbook.application;
    // app.suspendScreenUpdatingUntilNextSync();
    
    // check permissions
    

    // query and load relevant vars

    const queryBody = JSON.stringify({uid : connectionInfo["uid"]});

    const response = await fetch(`${connectionInfo.hostName}getRadarInputs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: queryBody,

    });

    const data = await response.json();
    
    opts["storeList"] = [];
    data["storeList"].forEach((item) => opts["storeList"].push(item.store_name));
    
    opts["departmentList"] = [];
    data["departmentList"].forEach((item) => opts["departmentList"].push(item));
        
    
    opts["vseSlsPeople"] = [''];
    data["vseSlsPeople"].forEach((item) => opts["vseSlsPeople"].push(item.emp_id));
    
    opts["vseFIPeople"] = [''];
    data["vseFIPeople"].forEach((item) => opts["vseFIPeople"].push(item.emp_id));
    
    opts["cddEmpIds"] = [];
    data["vseSlsPeople"].forEach((item) => opts["cddEmpIds"].push(item.emp_id)); //TEMP TODO add in correct people
    data["vseFIPeople"].forEach((item) => opts["cddEmpIds"].push(item.emp_id)); //TEMP TODO add in correct people
    


    opts["cddEmpIds"] = [];
    data["vseSlsPeople"].forEach((item) => opts["cddEmpIds"].push(item.emp_id)); //TEMP TODO add in correct people
    data["vseFIPeople"].forEach((item) => opts["cddEmpIds"].push(item.emp_id)); //TEMP TODO add in correct people
    

    // OTB
    opts["otbCategoriesByStore"] = [];
    data["otbCategoriesByStore"].forEach((item) => opts["otbCategoriesByStore"].push(item));
  
    
    // update html labels
    setHMTLInputOptionsAndDefaults();
    await setAsyncEventListeners();

    // check values of loaded tabs for validations

    // update timestamp
   
    // dev check on update - temp
    // showLoadedVariables();
  });
}

function hideAllTaskpaneDivs() {
  let list_divs = [
    "login-screen", "user-mgmt", "emp-mgmt", "load-vehicle-sales-form", "vehicle-sales-entry-form"
    , "vehicle-sales-manager-report-form", "vehicle-sales-gp-details-form", "vehicle-sales-leaderboard-form"
    , "fi-leaderboard-form", "daily-sales-form", "daily-sales-leaderboard-form", "cit-form", "com-payroll-form"
    , "cdd-form", "otb-gm-mtd-form", "otb-gm-batch-form", "otb-gm-recap-form", "otb-gm-cat-form"
    , "otb-gm-group-form", "otb-gm-sum-form", "dashboard-tab"
  ];
  list_divs.forEach((item) => {
    document.getElementById(item).style.display = "none";
  });     
}

async function clearSheet(context, wsName) {
  let ws = context.workbook.worksheets.getItemOrNullObject(wsName);
  ws.load("isNullObject");  
  await context.sync();

  if(ws.isNullObject) {
    console.log(`Sheet ${wsName} does not exist, nothing to clear.`);
    return; // if sheet doesn't exist, just return since there's nothing to clear
  }
  else {
    console.log(`Clearing sheet ${wsName}`);
    let app = context.workbook.application;
    // context.load(numCharts);
    await context.sync();
    
    ws.getRange("A:CC").clear();  // TODO magic number
    ws.getRange("A:CC").columnHidden = false;
    ws.freezePanes.unfreeze();
    
    let numCharts = ws.charts.getCount()
    app.suspendScreenUpdatingUntilNextSync();
    await context.sync();
    
    // Delete any charts already on the page
    for (let i = numCharts.value - 1; i >= 0; i--) {
      ws.charts.getItemAt(0).delete();
    };

    // await context.sync(); 
  };
}

async function loadDashboard(){
  await Excel.run(async (context) => {  
    await clearSheet(context, C.SHEET_NAME_HOME);
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_HOME);
    
    const dashMainTitle = "DEFCON 3 - Breathe Easier";
    const randomIndex = Math.floor(Math.random() * C.DASHBOARD_GREETINGS.length);
    const randomGreeting = C.DASHBOARD_GREETINGS[randomIndex];

    ws.getRange("A1").values = [[dashMainTitle]]; 
    ws.getRange("A2").values = [[randomGreeting]]; 
    ws.getRange("A4").values = [[`Logged in as ${connectionInfo.uid}`]];

    ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE
    ws.getRange("2:5").format.font.size = C.FONT_SIZE_SUBTITLE
    ws.getRange("A1").format.font.bold = true;
    ws.getRange("1:2").format.font.color = C.COLOR_HARLEY_BLACK
    ws.getRange("1:2").format.fill.color = C.COLOR_HARLEY_ORANGE; 
    ws.getRange("3:5").format.fill.color = "#FFFFFF"; 
    
    ws.getRange("5:100").format.fill.color = C.COLOR_DASH_BG;

    let numStores = 7 ; // TODO should we get the number of stores returned for this particular user first?
    
    let row_start = 6; // row 6
    let col_start = 1; // col B

    let offset_rows_per_card = 5 + numStores;
    let offset_cols_per_card = 9;

    const queryBody = JSON.stringify({uid : connectionInfo["uid"]});

    const response = await fetch(`${connectionInfo.hostName}loadRadarDashboard`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: queryBody
    });

    const data = await response.json();
    
    console.log("Dashboard data loaded from backend:", data);

    let cardData = [
      {
        cardTitle: 'Vehicle Sales - Units'
        , dataToWrite: [Object.keys(data['vehicleSales'][0]), ...data['vehicleSales'].map(item => Object.values(item))]
        , subheadings: [{start_col : 1, cols_wide: 2, desc : 'Write Ups'}
          , {start_col: 3, cols_wide: 2, desc: 'Units'}
          , {start_col: 5, cols_wide: 2, desc: 'Unit GP'}          
        ]
        , colFormats: [{col_name: 'GP MTD', format: C.CURRENCY_FORMAT_ROUNDED}, {col_name: 'GP MTD PY', format: C.CURRENCY_FORMAT_ROUNDED}]
        , offset_row: row_start + 0
        , offset_col: col_start + 0
        , tblName: 'RadarDashVSUnits' 
      }      
      , {
        cardTitle: 'Vehicle Sales - F&I'
        , dataToWrite: [Object.keys(data['fi'][0]), ...data['fi'].map(item => Object.values(item))]
        , subheadings: [{start_col: 1, cols_wide: 3, desc : 'F&I GP'}, {start_col: 4, cols_wide: 2, desc : 'CIT'}]
        , colFormats: [{col_name: 'MTD', format: C.CURRENCY_FORMAT_ROUNDED}, {col_name: 'PY MTD', format: C.CURRENCY_FORMAT_ROUNDED}]
        , offset_row: row_start + 0
        , offset_col: col_start + 1*offset_cols_per_card
        , tblName: 'RadarDashFI' 
      }
      ,{
        cardTitle: 'Daily Sales - Service'
        , dataToWrite: [Object.keys(data['service'][0]), ...data['service'].map(item => Object.values(item))]
        , subheadings: [{start_col : 1, cols_wide: 2, desc : 'Labor'}, {start_col : 3, cols_wide: 2, desc : 'Parts to WO!'}]
        , colFormats: [
              {col_name: 'Labor MTD', format: C.CURRENCY_FORMAT_ROUNDED}, {col_name: 'PY MTD', format: C.CURRENCY_FORMAT_ROUNDED}
            , {col_name: 'Parts To WO MTD', format: C.CURRENCY_FORMAT_ROUNDED}, {col_name: 'PY Parts MTD', format: C.CURRENCY_FORMAT_ROUNDED}
          ]
        , offset_row: row_start + 1*offset_rows_per_card
        , offset_col: col_start 
        , tblName: 'RadarDashService' 
      }
    ];

    // const dashTitleGM = "Daily Sales - GM";
    // const dashTitleParts = "Daily Sales - Parts";
    // const dashTitleOnline = "Daily Sales - Online";
    // const dashTitleIOTM = "Item of the Month";
    // const dashTitleCIT = "CIT";
    // const dashTitleTech = "Technician";
  
    let resultTbls = [];    
    for (let i in cardData) {
      await placeMonopolyCard(context, ws, cardData[i].dataToWrite, cardData[i].cardTitle, cardData[i].offset_row, 
        cardData[i].offset_col, cardData[i].subheadings, cardData[i].colFormats, cardData[i].tblName)

      resultTbls.push(ws.tables.getItem(cardData[i].tblName));
    }
    
    await formatStandardRadarReport(context, ws, resultTbls,
      C.SHEET_NAME_HOME, randomGreeting, C.COLOR_HEADER_HOME,
      C.COLOR_HEADER_FONT_HOME, "#FFFFFF", C.COLOR_HARLEY_BLACK, "", []);
    
    for (let i in resultTbls) {
      ws.tables.getItem(cardData[i].tblName).style = "TableStyleMedium3";
    };

    ws.activate();
    await context.sync();   
  });
}

async function placeMonopolyCard(context, ws, dataToWrite, dept_heading: string, offset_row: number, offet_col: number, subheadings, colFormats, tblName: string) {
  console.log(`placeMonopolyCard called ${dept_heading}`)  
  let cardWidth = dataToWrite[0].length - 1;
  let cardHeight = dataToWrite.length + 1;
  
  ws.getRange(`${offset_row+1}:${offset_row+3}`).format.rowHeight = C.ROW_HEIGHT_TBL_HEADER_DOUBLE;

  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 0}`).merge();
  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 0}`).format.horizontalAlignment = 'Center';
  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 0}`).format.font.size = C.FONT_SIZE_SUBTITLE;
  
  // ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + cardHeight}`).format.fill.color = '#FFFFFF';
  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + cardHeight}`).format.fill.clear();
  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 1}`).format.fill.color = C.COLOR_HARLEY_ORANGE;
  
  await addDataTable(context, ws, dataToWrite, `${numberToLetters(offet_col)}${offset_row + 2}`, tblName); 

  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}`).values = [[dept_heading]];
  ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 1}`).format.font.bold = true;

  for(let i in subheadings) {
    ws.getRange(`${numberToLetters(offet_col + subheadings[i].start_col)}${offset_row + 1}`).values = [[subheadings[i].desc]];
    ws.getRange(`${numberToLetters(offet_col + subheadings[i].start_col)}${offset_row + 1}:${numberToLetters(offet_col + subheadings[i].start_col + subheadings[i].cols_wide - 1)}${offset_row + 1}`).merge();
    // ws.getRange(`${numberToLetters(offet_col+0)}${offset_row + 0}:${numberToLetters(offet_col + cardWidth)}${offset_row + 0}`).merge();
    
    // TODO add formatting and merge cells

  }
  
  
  let resultTbl =  ws.tables.getItem(tblName);
  
  for(let i in colFormats) {
    resultTbl.columns.getItem(colFormats[i].col_name).getDataBodyRange().numberFormat = [[colFormats[i].format]];
  }
  return 'yay'

}

function numberToLetters(num) {
    let letters = ''
    while (num >= 0) {
        letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
        num = Math.floor(num / 26) - 1
    }
    return letters
}


async function loadVehicleSales() {
  await Excel.run(async (context) => {
    const inputStore = document.getElementById("lvs-store").value;
    const inputDateStart = document.getElementById("lvs-date-start").value;
    const inputDateEnd = document.getElementById("lvs-date-end").value;

    const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
    const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

    const inputs=[];
    // const reportDesc = "Showing Data for Store " + inputStore + " between " + strDateStart + " and " + strDateEnd;
    const reportDesc = `Showing Data for Store ${inputStore} between ${strDateStart} and ${strDateEnd}`;
    loadReport(C.SHEET_HEADER_VS_ENTRY, reportDesc, inputs);

  });
}

function clearVehicleSaleForm() {
//TODO Left to do: radio buttons, dropdowns on F&I Info tab

  let elementsToBlank = [
    "vse-unit-desc", "vse-trade-in-desc", "vse-sale-id", "vse-stock-num", "vse-fi-vin", "vse-fi-final-gp"
    , "vse-add-hd-promo", "vse-customer-name", "vse-fi-reserve", "vse-final-gp", "vse-flat", "vse-gp-esp"
    , "vse-gp-gap", "vse-gp-notes", "vse-gp-other", "vse-gp-tw", "vse-gp-vip", "vse-less-dpp", "vse-less-fees"
    , "vse-prod-other", "vse-final-gp", "vse-fi-final-gp"
  ];
  elementsToBlank.forEach((item) => {
    document.getElementById(item).value = "";
  });

  document.getElementById("vse-date").value = opts["dateDefaultEnd"];
  document.getElementById("vse-fi-id").innerHTML = opts["vseFIPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");    
  document.getElementById("vse-salesperson-1").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
  document.getElementById("vse-salesperson-2").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");    
  document.getElementById("vse-spiff").value = "";
  document.getElementById("vse-store").innerHTML = opts["storeList"].map(store => `<option value="${store}">${store}</option>`).join("");
  document.getElementById("vse-vehicle-gp-base").value = "";

  //TODO these options are hardcoded in the HTML - should it be loaded dynamically in case other products get added?
  document.getElementById("vse-prod-vip").value = "VIP";
  document.getElementById("vse-prod-esp").value = "ESP";
  // document.getElementById("vse-prod-gap").value = ""; //always GAP
  document.getElementById("vse-prod-tw").value = "T&W";
  
  document.getElementById("vse-fi-deal-f").checked = true;
  document.getElementById("vse-sale-type-n").checked = true;
}

async function editSelectedSale() {
  await Excel.run(async (context) => {
            // // await context.sync();
      // const intersection = rngTable.getIntersectionOrNullObject(rngSelected.getCell(0, 0));
      // intersection.load("address");
      // updateFooterStatus("test");
      // updateFooterStatus(intersection.address);
      updateFooterStatus("Editing Selected Sale");
      const ws = context.workbook.worksheets.getActiveWorksheet();
      const activeCell = context.workbook.getActiveCell();
      updateFooterStatus("Editing Selected Sale - Loading values");
      activeCell.load("values");
      activeCell.load('rowIndex');
      await context.sync();

      const rngSaleId = ws.getRange("AA" + (activeCell.rowIndex + 1)); //0-based index
      rngSaleId.load("values");
      await context.sync();

      updateFooterStatus(`Editing Selected Sale - Values loaded from row ${activeCell.rowIndex+1}.`);
      
      
      const activeRowID = rngSaleId.values[0][0];
      
      updateFooterStatus(`${activeRowID}.`);

      // const sale_id = 40571;// 33848; //TODO random test sale
      const sale_id = activeRowID;
      clearVehicleSaleForm();


      const response = await fetch(`${connectionInfo.hostName}loadVehicleSale`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({sale_id: sale_id, desc : "vse-edit" }),
      });

      const data = await response.json();

      document.getElementById("vse-unit-desc").value = data[0].unit_desc;
      document.getElementById("vse-trade-in-desc").value = data[0].trade_in_desc;
      document.getElementById("vse-sale-id").value = data[0].id;
      document.getElementById("vse-stock-num").value = data[0].stock_num;
      document.getElementById("vse-fi-vin").value = data[0].Fi_Vin;
      document.getElementById("vse-fi-final-gp").value = data[0].fi_final_gp;
      document.getElementById("vse-add-hd-promo").value = data[0].Vehicle_gp_add_hd_promo;
      document.getElementById("vse-customer-name").value = data[0].customer_name;
      document.getElementById("vse-date").value = data[0].date.split("T")[0];
      
      document.getElementById("vse-fi-reserve").value = data[0].Fi_reserve_profit;
      document.getElementById("vse-final-gp").value = data[0].vehicle_gp_total;
      document.getElementById("vse-flat").value = data[0].flat;
      document.getElementById("vse-gp-esp").value = data[0].fi_esp_gp;
      document.getElementById("vse-gp-gap").value = data[0].fi_gap_gp;
      document.getElementById("vse-gp-notes").value = data[0].Vehicle_gp_notes
      document.getElementById("vse-gp-other").value = data[0].fi_other_1_gp;
      document.getElementById("vse-gp-tw").value = data[0].fi_tire_wheel_gp;
      document.getElementById("vse-gp-vip").value = data[0].fi_vip_gp;
      document.getElementById("vse-less-dpp").value = data[0].Vehicle_gp_promo;
      document.getElementById("vse-less-fees").value = data[0].Vehicle_gp_less_fees;
      document.getElementById("vse-prod-esp").value = data[0].fi_esp;
      document.getElementById("vse-prod-gap").value = data[0].fi_gap;
      document.getElementById("vse-prod-other").value = data[0].fi_other_1;
      document.getElementById("vse-prod-vip").value = data[0].fi_vip;
      document.getElementById("vse-prod-tw").value = data[0].fi_tire_wheel;
      document.getElementById("vse-spiff").value = data[0].spiff;
      document.getElementById("vse-vehicle-gp-base").value = data[0].Vehicle_gp_base;
      
      if(data[0].fi_deal_type === "F") {
        document.getElementById("vse-fi-deal-f").checked = true;
      } else if(data[0].fi_deal_type === "C") {
        document.getElementById("vse-fi-deal-c").checked = true;
      } else {
        document.getElementById("vse-fi-deal-f").checked = false;
        document.getElementById("vse-fi-deal-c").checked = false;
      }

      if(data[0].sale_type === "F") {
        document.getElementById("vse-sale-type-f").checked = true;
      } else if(data[0].sale_type === "N") {
        document.getElementById("vse-sale-type-n").checked = true;
      } else if(data[0].sale_type === "U") {
        document.getElementById("vse-sale-type-u").checked = true;
      } else if(data[0].sale_type === "W") {
        document.getElementById("vse-sale-type-w").checked = true;
      } else {
        document.getElementById("vse-sale-type-f").checked = false;
        document.getElementById("vse-sale-type-n").checked = false;
        document.getElementById("vse-sale-type-u").checked = false;
        document.getElementById("vse-sale-type-w").checked = false;
      }
      
      // Check dropdown fiels - if the loaded value is not in the options (ex. new salesperson), add to options and set as selected value. If it is in the options, just set as selected value.

      if (! opts["vseSlsPeople"].includes(data[0].salesperson_1) ) {
        opts["vseSlsPeople"].push(data[0].salesperson_1);
        document.getElementById("vse-salesperson-1").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
        document.getElementById("vse-salesperson-2").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
      };
      if (! opts["vseSlsPeople"].includes(data[0].salesperson_2) ) {
        opts["vseSlsPeople"].push(data[0].salesperson_2);
        document.getElementById("vse-salesperson-1").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
        document.getElementById("vse-salesperson-2").innerHTML = opts["vseSlsPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");
      };
      
      document.getElementById("vse-salesperson-1").value = data[0].salesperson_1;
      document.getElementById("vse-salesperson-2").value = data[0].salesperson_2; 
  
      
      if (! opts["vseFIPeople"].includes(data[0].salesperson_1) ) {
        opts["vseFIPeople"].push(data[0].salesperson_1);
        document.getElementById("vse-fi-id").innerHTML = opts["vseFIPeople"].map(emp => `<option value="${emp}">${emp}</option>`).join("");  
      };      
      document.getElementById("vse-fi-id").value = data[0].fi_person;

      if (! opts["storeList"].includes(data[0].store) ) {
        opts["storeList"].push(data[0].store);
        document.getElementById("vse-store").innerHTML = opts["storeList"].map(emp => `<option value="${emp}">${emp}</option>`).join("");  
      };      
      document.getElementById("vse-store").value = data[0].store;

      updateVSEFinalGP(); // re-calculate total GP based on loaded components
      updateVSEFinalFIGP(); // re-calculate total GP based on loaded components

      await navTo(C.NAV_VS_ENTRY_ADD);
  });
}



async function loadReport(reportName, reportDesc, inputs) { //specifically VS Unit Entry - to do refactor back in, then abstract out for all reports
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_ENTRY);
    clearSheet(context, C.SHEET_NAME_VS_ENTRY);      
    
    const inputStore = document.getElementById("lvs-store").value;
    const inputDateStart = document.getElementById("lvs-date-start").value;
    const inputDateEnd = document.getElementById("lvs-date-end").value;
    const queryBody = JSON.stringify({reportName : "vehicleSalesList", inputStore : inputStore, inputDateStart: inputDateStart, inputDateEnd: inputDateEnd  });

    const response = await fetch(`${connectionInfo.hostName}getVehicleSalesList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: queryBody,
    });
 
    const data = await response.json();
    console.log("Data received from server:");
    console.log(data);

    if(data.length === 0) { // TODO abstract this out as a function calle eg displayNoDataMessage(ws, reportName, themeColor, errorMessage)
      ws.getRange("A1").values = [[reportName]];
      ws.getRange("A2").values = [["No data to show for the selected store and date range. Please adjust your filters and try again."]];
      
      ws.getRange("A1").format.font.bold = true;
      ws.getRange("A2").format.font.italic = true;
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; 
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; 
      ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;
      return;
    }
    
    // Assuming the JSON objects have consistent keys, extract headers and values
    const headers = Object.keys(data[0]);
    const values = data.map(item => Object.values(item));
    console.log("Extracted Headers:");
    console.log(headers);
    console.log("Extracted Values:");
    console.log(values);

    // Combine headers and values into a single 2D array
    const dataToWrite = [headers, ...values];

    // 3. Define the target range (e.g., starting at A1)
    const startCell = ws.getRange("B4");  // TODO magic number

    // Get the resized range based on the data dimensions
    const endRow = dataToWrite.length - 1;
    const endColumn = dataToWrite[0].length - 1;
    const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
    
    const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
    // resultTbl.name = "Table_Sales_List";

    // Set the values of the range
    range.values = dataToWrite;
    
    // Format the resulting table
    let cols_currency = [
      "SPIFF", "Flat", "GP", "Reserve", "VIP", "ESP", "GAP", "T&W", "Other", "Other 2", "Other 3", "Amount Financed", "Max Approval"
    ];
    cols_currency.forEach((col) => {
      resultTbl.columns.getItem(col).getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];  
    });  

    resultTbl.getDataBodyRange().format.autofitColumns();
    resultTbl.getDataBodyRange().format.autofitRows();

    ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; 
    ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; 
    ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;

    ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;
    ws.getRange("AA:AA").columnHidden = true; //TODO magic column

    resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD;
    resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD;
    
    // Freeze the specified range in top-and-left-most pane of the worksheet.
    ws.freezePanes.freezeAt(ws.getRange("A1:E4"));  // TODO magic number
  
    // Add conditional formats
    const conditionalFormat = resultTbl.getDataBodyRange().conditionalFormats.add(
         Excel.ConditionalFormatType.custom
    );
    conditionalFormat.custom.rule.formula = '=IF($X5>0,TRUE)'; // TODO magic number
    conditionalFormat.custom.format.fill.color = C.COLOR_COND_FORMAT_ATTENTION;

    // Add report title/info
    
    ws.getRange("A1").values = [[reportName]];  // TODO magic number
    ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
    ws.getRange("A2").format.font.italic = true; // TODO magic number
    ws.getRange("A2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
  });
}




async function loadVehicleManagerReport() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_VS_MGR_REPORT);

      let app = context.workbook.application;
      app.suspendScreenUpdatingUntilNextSync();
      
      const inputDateStart = document.getElementById("vsm-date-start").value;
      const inputDateEnd = document.getElementById("vsm-date-end").value;
      
      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

      const reportDesc = "Showing Vehicle Sales between " + strDateStart + " and " + strDateEnd;
      // const chartTitle = "Gross Profit " + strDateStart + " to " + strDateEnd;

      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_MGR_REPORT);

      app.suspendScreenUpdatingUntilNextSync();
      
      const response = await fetch(`${connectionInfo.hostName}getVehicleSalesMgrReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd  }),
      });

      const data = await response.json();
      
      // Assuming the JSON objects have consistent keys, extract headers and values
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));

      // Combine headers and values into a single 2D array
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      // resultTbl.name = "Table_whatever";

      // Set the values of the range
      range.values = dataToWrite;
           
      
      // // Format the resulting table
      resultTbl.columns.getItem("Vehicle GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("PY Vehicle GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("GP PUS").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("PY Vehicle GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("F&I GP PUS").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("PY F&I GP PUS").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("F&I GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();

      
      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_VS_MGR_REPORT]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number

      //Apply other formatting

      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_VS_MGR_REPORT; 
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("A2").format.font.color =  C.COLOR_HEADER_VS_MGR_REPORT; 
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_VS_MGR_REPORT; 
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      
      // Add conditional formats
      // const conditionalFormat = resultTbl.getDataBodyRange().conditionalFormats.add(
      //     Excel.ConditionalFormatType.custom
      // );
      // conditionalFormat.custom.rule.formula = '=IF($X5>0,TRUE)'; // TODO magic number
      // conditionalFormat.custom.format.fill.color = "#d55f4b"; //TODO magic color

      // // Add the Chart  
      // let chart = ws.charts.add(
      //   Excel.ChartType._3DColumnClustered,
      //   resultTbl.columns.getItem("Vehicle GP").getDataBodyRange(),
      //   Excel.ChartSeriesBy.auto);

      // // chart.left = resultTbl.getDataBodyRange().left;
      // chart.left = 100;
      // chart.top = 200;
      
      
      
      // chart.axes.categoryAxis.title.text = "Store";
      // chart.axes.valueAxis.title.text = "Gross Profit";

      // chart.series.getItemAt(0).name = "Vehicle GP";
      // let newSeries = chart.series.add("F&I GP");
      // newSeries.setValues(resultTbl.columns.getItem("F&I GP").getDataBodyRange());

      // chart.title.text = chartTitle
      // chart.legend.position = Excel.ChartLegendPosition.right;
      // chart.legend.format.fill.setSolidColor("white");
      // chart.dataLabels.format.font.size = 15;
      // chart.dataLabels.format.font.color = "black";
    
      ws.activate();
    });
}

async function loadVehicleGPReport() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_VS_GP_DETAILS);

      let app = context.workbook.application;
      app.suspendScreenUpdatingUntilNextSync();
       
      const inputDateStart = document.getElementById("vgpd-date-start").value;
      const inputDateEnd = document.getElementById("vgpd-date-end").value;
      const inputStore = document.getElementById("vgpd-store").value;
      const inputType = document.getElementById("vgpd-type").value;

      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

      const reportDesc = "Showing Vehicle Sales for Store " + inputStore + " between " + strDateStart + " and " + strDateEnd;
      
      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_GP_DETAILS);

      const response = await fetch(`${connectionInfo.hostName}getVehicleSalesGPDetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd, inputStore : inputStore, inputType :inputType }),
      });

      const data = await response.json();
      
      // Assuming the JSON objects have consistent keys, extract headers and values
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));

      // Combine headers and values into a single 2D array
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      // resultTbl.name = "Table_whatever";

      // Set the values of the range
      range.values = dataToWrite;
      
      // // // Format the resulting table
      resultTbl.columns.getItem("Vehicle GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Less DPP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Less Fees").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Add HD Promo").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Final GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];

      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();

      
      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_VS_GP_DETAILS]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number

      //Apply other formatting

      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("A2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      
      
      ws.getRange("M:M").columnHidden = true; // TODO Magic column
    });
}

async function loadVehicleSalesLeaderboard() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_VS_LEADERBOARD);
      let app = context.workbook.application;
      app.suspendScreenUpdatingUntilNextSync();
      
      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_VS_LEADERBOARD);

      const inputDateStart = document.getElementById("vsl-date-start").value;
      const inputDateEnd = document.getElementById("vsl-date-end").value;

      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});
                                                                          
      const reportDesc = "Showing Vehicle Sales between " + strDateStart + " and " + strDateEnd;

      const response = await fetch(`${connectionInfo.hostName}getVehicleSalesLeaderboard`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd}),
      });

      const data = await response.json();
      
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      range.values = dataToWrite;

      //Apply formatting
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("A2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      
      resultTbl.columns.getItem("GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();

      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_VS_LEADERBOARD]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number


      // Chart
      // 3d clustered bar

    
      // // let chartRange = ws.getRange("C4:C" + (4 + endRow) + ", I4:I" + (4 + endRow) ); //TODO sloppy
      // let chartRange = ws.getRange("C4:D" + (4 + endRow) ); //TODO sloppy
      // // let chartRange = ws.getRanges("Z2:Z3, Z5");

      // let chart = ws.charts.add(
      //   Excel.ChartType._3DBarClustered,
      //   chartRange
      // );


      // let dataRange = sheet.getRange("D2:D5");

      // let newSeries = chart.series.add("GP");
      // newSeries.setValues(ws.getRange("I4:I" + (4 + endRow)));

      // chart.axes.categoryAxis.reversePlotOrder = true;

      // //=address(C5:C8,I5:I9)
      // chart.left = 500;
      // chart.top = 100; //TODO make dynamic
      
      // //Hide the Gross Profit duplicate column but still include in the chart
      // chart.plotVisibleOnly = false;
      ws.getRange("D:D").columnHidden = true; //TODO magic column

      ws.activate();

    });
}

async function loadFILeaderboard() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_FI_LEADERBOARD);
      
      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_FI_LEADERBOARD);
      
      const inputDateStart = document.getElementById("fil-date-start").value;
      const inputDateEnd = document.getElementById("fil-date-end").value;
      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

      const reportDesc = "Showing F&I Sales between " + strDateStart + " and " + strDateEnd;

      // const chartTitle = "Gross Profit " + strDateStart + " to " + strDateEnd;

      const response = await fetch(`${connectionInfo.hostName}getFILeaderboard`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd}),
      });

      const data = await response.json();
      
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      range.values = dataToWrite;

      //Apply formatting
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("A2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      
      resultTbl.columns.getItem("GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("GP PUS").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();

      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_FI_LEADERBOARD]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
      
      // let chartRange = ws.getRange("C4:D" + (4 + endRow)); //TODO sloppy

      // let chart = ws.charts.add(
      //   Excel.ChartType._3DBarClustered,
      //   chartRange
      // );

      // chart.axes.categoryAxis.reversePlotOrder = true; // show biggest number on top instead of on bottom

      // //TODO finish chart:
      // //-Add title
      // //-formatting, location
      // chart.left = 100;
      // chart.top = 500;

      ws.activate();
      
      
    });
}

async function loadCIT() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_CIT);
      
      const LOCAL_DATE = "mm/dd/yyyy";

      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_CIT);
      
      const inputDateStart = document.getElementById("cit-date-start").value;
      const inputDateEnd = document.getElementById("cit-date-end").value;
      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

      const inputStore = document.getElementById("cit-store").value;

      // const inputDataset = document.getElementById("cit-dataset").value;
      
      const inclAllIncomplete = document.getElementById("cit-include-all-incomplete").checked;
      const inclComplete = document.getElementById("cit-include-complete").checked;

      const reportDesc = "Showing CIT data for store " + inputStore + " between " + strDateStart + " and " + strDateEnd;
      
      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_CIT]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
      
      const response = await fetch(`${connectionInfo.hostName}getCITReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd, inputStore: inputStore, inclAllIncomplete: inclAllIncomplete, inclComplete: inclComplete}),
      });

      const data = await response.json();
      
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      range.values = dataToWrite;

      
      //Fetch the total financed values
      const responseTotals = await fetch(`${connectionInfo.hostName}getCITReportTotals`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd, inputStore: inputStore, inclAllIncomplete: inclAllIncomplete, inclComplete: inclComplete}),
      });

      const dataTot = await responseTotals.json();
      
      const headersTot = Object.keys(dataTot[0]);
      const valuesTot = dataTot.map(item => Object.values(item));
      const dataToWriteTot = [headersTot, ...valuesTot];
      
      ws.getRange("L1:O2").values = dataToWriteTot; // todo MAGIC Address
      ws.getRange("L2:O2").numberFormat = [[C.CURRENCY_FORMAT]]; // TODO Magic address



      //Apply formatting
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      
      resultTbl.columns.getItem("Amount Financed").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Holdcheck Amount").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Floorplan Amount").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Trade Payoff").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Net Cash").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];

      resultTbl.columns.getItem("Deposit Date of Holdcheck").getDataBodyRange().numberFormat = [[LOCAL_DATE]];
      
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();
      
      // Freeze the specified range in top-and-left-most pane of the worksheet.
      ws.freezePanes.freezeAt(ws.getRange("A1:C4"));  // TODO magic number
    
    });
}


async function editCITSale() {
    await Excel.run(async (context) => {
      
      const ws = context.workbook.worksheets.getActiveWorksheet();
      let rngSelected = context.workbook.getSelectedRange();
      rngSelected.load("address");

      let rngTable = ws.tables.getItemAt(0).getDataBodyRange();

      await context.sync();
      const intersection = rngTable.getIntersectionOrNullObject(rngSelected.getCell(0, 0));

      if (intersection.isNullObject) {
        document.getElementById("edit-cit-status").innerHTML = "Invalid Sale Selected";         
      }
      else {
        document.getElementById("edit-cit-status").innerHTML = "Editing Sale...";         
      }

      rngSelected.getCell(0, 0).values=[[rngSelected.address]]; // TEST ONLY - writes the full address of the selected range to the first (top left) cell within it
      //proof of concept - get the row selected and find the corresponding table id to load into the CIT edit form
          

    });
}

async function loadCommissionReport() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_COMMISSION_PAYROLL);

      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_COMMISSION_PAYROLL);

      const inputDateStart = document.getElementById("com-date-start").value;
      const inputDateEnd = document.getElementById("com-date-end").value;
      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});

      const inputStore = document.getElementById("com-store").value;

      const reportDesc = "Showing payroll data for store " + inputStore + " between " + strDateStart + " and " + strDateEnd;
      
      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_COMMISSION_PAYROLL]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
      
      const response = await fetch(`${connectionInfo.hostName}getPayrollReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd, inputStore: inputStore}),
      });

      const data = await response.json();
      
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      range.values = dataToWrite;

      //Apply formatting
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.bold = true;
      ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color

      resultTbl.columns.getItem("Vehicle").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("SPIFF").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Flat").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Reserve").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("VIP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("ESP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("GAP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("T&W").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Other FI").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Total Commission").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];      
          
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();

      ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;
      
      // Freeze the specified range in top-and-left-most pane of the worksheet.
      ws.freezePanes.freezeAt(ws.getRange("1:4"));  // TODO magic number
    
    });
}

async function loadCommissionDrilldownReport() {
    await Excel.run(async (context) => {
      await clearSheet(context, C.SHEET_NAME_COMMISSION_DRILLDOWN);
    
      const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_COMMISSION_DRILLDOWN);

      const inputDateStart = document.getElementById("cdd-date-start").value;
      const inputDateEnd = document.getElementById("cdd-date-end").value;
      const strDateStart = new Date(inputDateStart).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const strDateEnd = new Date(inputDateEnd).toLocaleDateString("en-us", {timeZone: 'UTC'});
      const inputEmpID = document.getElementById("cdd-emp-id").value;

      const inputStore = document.getElementById("cdd-store").value;

      const reportDesc = `Showing payroll data for ${inputEmpID} at Store ${inputStore} between ${strDateStart} and ${strDateEnd}`;
      
      // Add report title/info
      ws.getRange("A1").values = [[C.SHEET_HEADER_COMMISSION_DRILLDOWN]];  // TODO magic number
      ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
      
      const response = await fetch(`${connectionInfo.hostName}getPayrollDrilldownReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({inputDateStart: inputDateStart, inputDateEnd: inputDateEnd, inputStore: inputStore, inputEmpID : inputEmpID}),
      });

      const data = await response.json();
      
      const headers = Object.keys(data[0]);
      const values = data.map(item => Object.values(item));
      const dataToWrite = [headers, ...values];

      // 3. Define the target range (e.g., starting at A1)
      const startCell = ws.getRange("B4");  // TODO magic number

      // Get the resized range based on the data dimensions
      const endRow = dataToWrite.length - 1;
      const endColumn = dataToWrite[0].length - 1;
      const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
      
      const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
      range.values = dataToWrite;

      //Apply formatting
      ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
      ws.getRange("1:1").format.font.bold = true;
      ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

      ws.getRange("A2").format.font.italic = true; // TODO magic number
      ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
      
      resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
      resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color

      resultTbl.columns.getItem("Vehicle").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("SPIFF").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Flat").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Reserve").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("VIP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("ESP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("GAP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("T&W").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Other FI").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
      resultTbl.columns.getItem("Total Commission").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];      
          
      resultTbl.getDataBodyRange().format.autofitColumns();
      resultTbl.getDataBodyRange().format.autofitRows();
      ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;
      
      // Freeze the specified range in top-and-left-most pane of the worksheet.
      ws.freezePanes.freezeAt(ws.getRange("1:4"));  // TODO magic number
    
    });
}


async function vseChangeStoreVal() {
  await Excel.run(async (context) => {
    
  });
}


async function addOrUpdateVehicleSale() {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getActiveWorksheet();
      await context.sync();      

      const sale_id = document.getElementById("vse-sale-id").value;

      const dateSale = document.getElementById("vse-date").value;
      const store = document.getElementById("vse-store").value;
      const customer_name = document.getElementById("vse-customer-name").value;

      let sale_type = null;
      if (document.getElementById("vse-sale-type-n").checked) {
        sale_type = "N";
      } else if (document.getElementById("vse-sale-type-u").checked) {
        sale_type = "U";
      } else if (document.getElementById("vse-sale-type-w").checked) {
        sale_type ="W";
      } else if (document.getElementById("vse-sale-type-f").checked) {
        sale_type = "n/a";
      } else {
        // throw new Error("No sale type selected");
      }

      const salesperson_1 = document.getElementById("vse-salesperson-1").value;
      const salesperson_2 = document.getElementById("vse-salesperson-2").value;
      
      let salesperson_1_units = 0;
      let salesperson_2_units = 0;
      
      if (sale_type == "N"  || sale_type == "U")
      {
        if (salesperson_1 && salesperson_2) {
          salesperson_1_units = .5;
          salesperson_2_units = .5;
        } else if(salesperson_1) {
          salesperson_1_units = 1;
          salesperson_2_units = 0;
        } else if(salesperson_2) {
          salesperson_1_units = 0;
          salesperson_2_units = 1;
        }
        else {
          salesperson_1_units = 0;
          salesperson_2_units = 0;
        }
      } else { //sales units only apply to new and used sales
          salesperson_1_units = 0;
          salesperson_2_units = 0;        
      }

      let fi_deal_type = null;
      if (document.getElementById("vse-fi-deal-f").checked) {
        fi_deal_type = "F";
      } else if (document.getElementById("vse-fi-deal-c").checked) {
        fi_deal_type = "C";
      } else {
        // throw new Error("No deal type selected");
      }
      
      let stock_num = document.getElementById("vse-stock-num").value;
      let unit_desc = document.getElementById("vse-unit-desc").value;
      let trade_in_desc = document.getElementById("vse-trade-in-desc").value;
      
      // The following fields need to get the numeric value of the strings 
      // that is, if we go with that route instead of just sticking to input type=number fields
      let spiff = document.getElementById("vse-spiff").value;
      let flat = document.getElementById("vse-flat").value;
      let Vehicle_gp_base = document.getElementById("vse-vehicle-gp-base").value;
      let Vehicle_gp_promo = document.getElementById("vse-less-dpp").value;
      let Vehicle_gp_total = document.getElementById("vse-final-gp").value;
      let Vehicle_gp_less_fees = document.getElementById("vse-less-fees").value;
      let Vehicle_gp_add_hd_promo = document.getElementById("vse-add-hd-promo").value;
      
      let fi_vip_gp = document.getElementById("vse-gp-vip").value;
      let fi_esp_gp = document.getElementById("vse-gp-esp").value;
      let fi_gap_gp = document.getElementById("vse-gp-gap").value;
      let fi_tire_wheel_gp = document.getElementById("vse-gp-tw").value;
      let fi_reserve_profit = document.getElementById("vse-fi-reserve").value;
      let fi_other_1_gp = document.getElementById("vse-gp-other").value;
      let fi_total_gp = document.getElementById("vse-fi-final-gp").value;
      // let fi_total_gp_custom = document.getElementById("").value;
      let Vehicle_gp_notes = document.getElementById("vse-gp-notes").value;
      let fi_vin = document.getElementById("vse-fi-vin").value;
      let fi_vip = document.getElementById("vse-prod-vip").value;
      let fi_esp = document.getElementById("vse-prod-esp").value;
      let fi_gap = document.getElementById("vse-prod-gap").value;
      let fi_tire_wheel = document.getElementById("vse-prod-tw").value;
      let fi_other_1 = document.getElementById("vse-prod-other").value;
      // let fi_max_approval = document.getElementById("").value;
      // let fi_financed_amount = document.getElementById("").value;
      let fi_person = document.getElementById("vse-fi-id").value;

      let salesperson_1_gp = Vehicle_gp_total * salesperson_1_units;
      let salesperson_2_gp = Vehicle_gp_total * salesperson_2_units;

      let store_id = Object.keys(opts['storeLookup']).find(key => opts['storeLookup'][key] === store);

      const response = await fetch(`${connectionInfo.hostName}addEditVehicleSale`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            store: store
          , dateSale: dateSale
          , customer_name : customer_name
          , salesperson_1 : salesperson_1
          , salesperson_2 : salesperson_2
          , salesperson_1_units : salesperson_1_units
          , salesperson_2_units: salesperson_2_units
          , sale_type : sale_type
          , fi_deal_type : fi_deal_type
          , stock_num : stock_num
          , unit_desc : unit_desc
          , trade_in_desc : trade_in_desc
          , spiff : spiff
          , flat : flat
          , Vehicle_gp_base : Vehicle_gp_base
          , Vehicle_gp_promo : Vehicle_gp_promo
          , Vehicle_gp_total : Vehicle_gp_total
          , Vehicle_gp_less_fees : Vehicle_gp_less_fees
          , Vehicle_gp_add_hd_promo : Vehicle_gp_add_hd_promo
          , Vehicle_gp_notes : Vehicle_gp_notes
          , fi_vip_gp : fi_vip_gp
          , fi_esp_gp  : fi_esp_gp 
          , fi_gap_gp : fi_gap_gp
          , fi_tire_wheel_gp : fi_tire_wheel_gp
          , fi_reserve_profit : fi_reserve_profit
          , fi_other_1_gp : fi_other_1_gp
          , fi_total_gp : fi_total_gp
          , fi_vin : fi_vin
          , fi_vip : fi_vip
          , fi_esp : fi_esp
          , fi_gap : fi_gap
          , fi_tire_wheel : fi_tire_wheel
          , fi_other_1 : fi_other_1
          , fi_person : fi_person
          , sale_id : sale_id
          , salesperson_1_gp : salesperson_1_gp
          , salesperson_2_gp : salesperson_2_gp
          , store_id : store_id
        }),
      });

    });
}


//Tab behavior for the Vechile Sales Entry form
function openVSETabVI() {
  //Hide other tabs
  let tabFI = document.getElementById("vse-tab-fi");
  let tabBtnFI = document.getElementById("vse-btn-tab-fi");
  tabFI.style.display = "none";
  tabBtnFI.className = tabBtnFI.className.replace(" active", "");

  //Reveal this tab
  let tabVI = document.getElementById("vse-tab-vi");
  let tabBtnVI = document.getElementById("vse-btn-tab-vi");
  
  tabVI.style.display = "block";
  tabBtnVI.className += " active";  
}
function openVSETabFI() {
  //Hide other tabs
  let tabVI = document.getElementById("vse-tab-vi");
  let tabBtnVI = document.getElementById("vse-btn-tab-vi");
  tabVI.style.display = "none";
  tabBtnVI.className = tabBtnVI.className.replace(" active", "");

  //Reveal this tab
  let tabFI = document.getElementById("vse-tab-fi");
  let tabBtnFI = document.getElementById("vse-btn-tab-fi");
  
  tabFI.style.display = "block";
  tabBtnFI.className += " active";  
}

async function populateUMDepartmentInputs() {
  // The user management tab has checkboxes for every possible store/department combination.
  // Because stores and departments may be added down the line, we need to dynamically create the HTML checkboxes after querying the database at runtime

  // console.log(opts["storeList"])
  // console.log(opts["departmentList"])
  let umDeptMapping = document.getElementById('um-dynamic-store-dept-list');
  umDeptMapping.innerHTML = '';  // clear in case it has already been loaded
      
  for (let store in opts["storeList"]) {
    let storeDiv = document.createElement('div');
    umDeptMapping.appendChild(storeDiv);
   
    let storeHeader = document.createElement('h3')
    storeDiv.appendChild(storeHeader);
    storeHeader.appendChild(document.createTextNode(opts["storeList"][store]));

    let storeDivDeptList = document.createElement('div');
    storeDiv.appendChild(storeDivDeptList);
    storeDivDeptList.className="grid-container-um-depts";

    for (let dept in opts["departmentList"]) {
      let deptDiv = document.createElement('div');
      storeDivDeptList.append(deptDiv);

      // console.log(`adding dept ${opts["storeList"][store]} - ${opts["departmentList"][dept].id} - ${opts["departmentList"][dept].department_name}`)
      let elName =  `um-store-${opts["storeList"][store]}-dept-${opts["departmentList"][dept].id}`;
      let checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.name = elName;
      checkbox.value = elName;
      checkbox.id = elName;
      deptDiv.appendChild(checkbox);    
    
      let label = document.createElement('label')
      label.htmlFor = elName;
      label.style.float = "right";
      label.style.display = "inline-block";

      label.appendChild(document.createTextNode(opts["departmentList"][dept].department_name));
      deptDiv.appendChild(label);
    }
  };
}

async function loadUserManagement() {
  await Excel.run(async (context) => {
    let hideInactive = document.getElementById("um-load-users-hide-inactive").checked;
    const response = await fetch(`${connectionInfo.hostName}getUMUserList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
          uid : connectionInfo.uid
        , hideInactive: hideInactive
      })
    });
    
    const data = await response.json();
  
    if(response.status === 200) { // OK
      //Populate in opts[], then populate the user list on the frontend by updating the um-user-select dropdown
      
      opts["umUserList"] = data["report_body"];
      
      // console.log(opts["umUserList"]);
      let htmlSelect = `<option value="${-1}">${C.UM_SELECT_USER_TEXT}</option>`
      document.getElementById("um-user-select").innerHTML = htmlSelect + opts["umUserList"].map(emp => `<option value="${emp['id']}">${emp['Name']}</option>`).join("");    

      //Reveal the UM main div
      document.getElementById("um-main-div").style.display = "grid";  

    } else { //not ok      
        updateFooterStatus(`${new Date().toLocaleTimeString()} - trouble loading user list. Error code: ${response.status}`);

    };
  });
}

async function loadUMUserInfoIfNoUnsavedChanges() {
  await Excel.run(async (context) => {
      console.log("loadUMUserInfoIfNoUnsavedChanges");

      // Are there unsaved changes in the form? TODO
      // If so does the user want to save or  TODO


      const userIDNum = document.getElementById("um-user-select").value;

      // Clear the form
      document.getElementById("um-uid").value = "";
      document.getElementById("um-first-name").value = "";
      document.getElementById("um-last-name").value = "";
      document.getElementById("um-reg-date").value = "";
      // document.getElementById("um-password").value = "";
      // document.getElementById("um-confirm-password").value = "";
      document.getElementById("um-admin").checked = false;
      document.getElementById("um-active").checked = false;

      const container = document.getElementById('um-dynamic-store-dept-list');

      const elements = container.querySelectorAll('input[type="checkbox"]');
      for (const child of elements) {
        child.checked = false;
      }
      
      if(userIDNum < 0) { // then it's our placeholder and we should leave the form blank
        //no action required
      }
      else {// Load the user details from opts["umUserList"]        
        // Load their permissions from the database and populate
        const response = await fetch(`${connectionInfo.hostName}getUMUserDetails`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({uidNum : userIDNum})
        });
        
        const data = await response.json();
        const userInfo = data['rowsUser'][0];
        // console.log(data['rowsUser'])
        // console.log(data['rowsDepts'])
        opts["umLoadedUserInfo"] = userInfo;
        opts["umLoadedUserAssignedDepts"] = data['rowsDepts'];
      
        if(response.status === 200) { // OK
          document.getElementById("um-uid").value = userInfo.username;
          document.getElementById("um-first-name").value = userInfo.first_name;
          document.getElementById("um-last-name").value = userInfo.last_name;
          document.getElementById("um-reg-date").value = userInfo.date_registered;
          document.getElementById("um-admin").checked = (userInfo.is_admin > 0);
          document.getElementById("um-active").checked = (userInfo.is_active > 0);
          
          //Now loop through the depts they belong to and check the appropriate boxes
          // console.log(data['rowsDepts'])
          for(const row in data['rowsDepts']) {
            try {
              if (data['rowsDepts'][row].department_id != null) {
                const elName = `um-store-${data['rowsDepts'][row].store_name}-dept-${data['rowsDepts'][row].department_id}`;
                document.getElementById(elName).checked = true;
              }
            } catch (error) {
                // Note: In a production add-in, you'd want to notify the user through your add-in's UI.
                console.error(error);
            }
          }
            
        }
        else {
          updateFooterStatus(`${new Date().toLocaleTimeString()} - trouble loading user details. Error code: ${response.status}`);
        }
      }
      
  })
};


//FOR createUserAccount:

      // //First check if the PWs match
      // if(pw !== pw_confirm) {
      //   //Mark PW fields as red and add warning label
      //   document.getElementById("um-confirm-password").style = "grid";
      // }
      // else {}


async function updateUserAccount() {
    await Excel.run(async (context) => {
      console.log('updateUserAccount');
      const uid = document.getElementById("um-uid").value;
      let user_id = opts["umLoadedUserInfo"].id;

      const first_name = document.getElementById("um-first-name").value;
      const last_name = document.getElementById("um-last-name").value;
      const date_registered = document.getElementById("um-reg-date").value;
      // const pw = document.getElementById("um-password").value;
      // const pw_confirm = document.getElementById("um-confirm-password").value;
      const is_admin = document.getElementById("um-admin").checked;
      const is_active = document.getElementById("um-active").checked;
      
      //Determine which checkboxes are checked
      //Perhaps better to see which checkbox values have been changed - that way we don't have to rewrite all their DB entries
            
      // console.log(opts["umLoadedUserAssignedDepts"])
      let deptsToAdd = [];
      let deptsToRemove = [];
      
      for (let i in opts["storeList"]) {
        for (let j in opts["departmentList"]) {
          let store = opts["storeList"][i];
          let store_id = parseInt(Object.keys(opts['storeLookup']).find(key => opts['storeLookup'][key] === store));

          let dept = opts["departmentList"][j].id;
          let elName =  `um-store-${store}-dept-${dept}`;
          //const elName = `um-store-${data['rowsDepts'][row].store_name}-dept-${data['rowsDepts'][row].department_id}`;
          //Were they previously assigned to this dept? umLoadedUserAssignedDepts
          let loadedDeptIfPresent = opts["umLoadedUserAssignedDepts"].find(u => u.store_name === store && u.department_id === dept);
          // console.log(loadedDeptIfPresent);
          // const result = users.find(u => u.id === 3 && u.status === 'active');
          if(document.getElementById(elName).checked) {
            // console.log(`YES: ${store} - ${dept}`);
            if (loadedDeptIfPresent == null) { //then it was added!
              deptsToAdd.push({"store_id":store_id, "department_id":dept, "user_id":user_id, test:'test'});
            }
          }
          else {
            // console.log(`NO:  ${store} - ${dept}`);
            if (loadedDeptIfPresent != null) { //then it was removed!
              deptsToRemove.push({store_id:store_id, department_id:dept, user_id:user_id});
            }            

          }
        };
      };
      // 
      // opts['umLoadedUserAssignedDepts'];

      //await context.sync();
      console.log(deptsToAdd);

      const response = await fetch(`${connectionInfo.hostName}updateUserAccount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            username : uid
          , first_name : first_name
          , last_name : last_name
          , date_registered : date_registered
          , is_admin : is_admin
          , is_active : is_active
          // , raw_pass : pw      
          , deptsToAdd: deptsToAdd    
          , deptsToRemove : deptsToRemove

        }),
      });

      const data = await response.json();
      // If status is 200, clear screen by selecting the 'Select User' dropdown and letting the report load an empty user
      // If status is not 200, warn user and do not clear
      if(response.status === 200) { // OK
          
        updateFooterStatus(`${new Date().toLocaleTimeString()} - user ${uid} updated successfully.`);
        document.getElementById("um-user-select").value = -1;
        loadUMUserInfoIfNoUnsavedChanges();
        document.getElementById("um-user-select").focus();


        //todo see if that triggers the change event or not
      } else { // bad
        updateFooterStatus(`${new Date().toLocaleTimeString()} - failed to update user ${uid}. Server responded with status ${response.status}`);
      }
    });
}

function updateFooterStatus(strMsg)
{
  document.getElementById("footer-status-msg").innerText = strMsg + "\n" + document.getElementById("footer-status-msg").innerText;
}

function clearFooterStatus() {
  document.getElementById("footer-status-msg").innerText = '';
}

function clearAndHideLoginDiv() {
  // Hide the login screen and THEN clear the form (because natural language and logic best practices don't always line up)
  document.getElementById("login-screen").style.display = "none";  
  document.getElementById("login-user").value = "";
  document.getElementById("login-password").value = "";
}

async function btnLoginOnClick() {
  await Excel.run(async (context) => {
    const uid = document.getElementById("login-user").value;
    const pw = document.getElementById("login-password").value;
    await tryToLogIn(uid, pw);
  });
}

async function tryToLogIn(uid, pw) {
    await Excel.run(async (context) => {
      const LI_STATUS_INITIATED = 0;
      const LI_STATUS_SUCCESS = 1;
      const LI_STATUS_VARS_LOADED = 2;
      const LI_STATUS_SHEETS_ADDED = 3;
      const LI_STATUS_DASHBOARD_LOADED = 4;

      updateFooterStatus(`${new Date().toLocaleTimeString()} - Initiating login attempt!`);
      let loginProgress = 0;

      try {
        // let loginAbortController = new AbortController(); // TO DO look into implenting AbortControllers to handle simple/graceful event handling
        loginProgress = LI_STATUS_INITIATED; // track how far we are along, to make status updates more informative.

        const response = await fetch(`${connectionInfo.hostName}loginRequest`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
                uid : uid
              , pw : pw
          }),
          signal: AbortSignal.timeout(2000)
        });

        const data = await response.json();

        updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt completed with status ${response.status}`);

        if(response.status === 200) { // OK
          //Credentials successful
          //Parse body of response to set user permissions and info

          connectionInfo.uid = uid;      
          connectionInfo.logged_in = true;
          loginProgress = LI_STATUS_SUCCESS;
          refreshLoadedVariables();
          
          
          // hideAllTaskpaneDivs();
          clearAndHideLoginDiv();

          document.getElementById("nav-login-screen").textContent = "Logout";
          document.getElementById("defcon-navigation").style.display = "grid";
          document.getElementById("defcon-nav-mini").style.display = "grid";
          

          loginProgress = LI_STATUS_VARS_LOADED;
          await addRadarSheet(C.SHEET_NAME_HOME, C.SHEET_HEADER_HOME, C.COLOR_HEADER_HOME, 'todo');
          await addRadarSheet(C.SHEET_NAME_VS_ENTRY, C.SHEET_HEADER_VS_ENTRY, C.COLOR_HEADER_VS_ENTRY, 'todo');
          await addRadarSheet(C.SHEET_NAME_VS_MGR_REPORT, C.SHEET_HEADER_VS_MGR_REPORT, C.COLOR_HEADER_VS_MGR_REPORT, 'todo');
          await addRadarSheet(C.SHEET_NAME_VS_GP_DETAILS, C.SHEET_HEADER_VS_GP_DETAILS, C.COLOR_HEADER_VS_GP_DETAILS, 'todo');
          await addRadarSheet(C.SHEET_NAME_VS_LEADERBOARD, C.SHEET_HEADER_VS_LEADERBOARD, C.COLOR_HEADER_VS_LEADERBOARD, 'todo');
          await addRadarSheet(C.SHEET_NAME_FI_LEADERBOARD, C.SHEET_HEADER_FI_LEADERBOARD, C.COLOR_HEADER_FI_LEADERBOARD, 'todo');
          await addRadarSheet(C.SHEET_NAME_DAILY_SALES, C.SHEET_HEADER_DAILY_SALES, C.COLOR_HEADER_DAILY_SALES, 'todo');
          await addRadarSheet(C.SHEET_NAME_LEADERBOARD, C.SHEET_HEADER_LEADERBOARD, C.COLOR_HEADER_LEADERBOARD, 'todo');
          await addRadarSheet(C.SHEET_NAME_CIT, C.SHEET_HEADER_CIT, C.COLOR_HEADER_CIT, 'todo');
          await addRadarSheet(C.SHEET_NAME_COMMISSION_PAYROLL, C.SHEET_HEADER_COMMISSION_PAYROLL, C.COLOR_HEADER_COMMISSION_PAYROLL, 'todo');
          await addRadarSheet(C.SHEET_NAME_COMMISSION_DRILLDOWN, C.SHEET_HEADER_COMMISSION_DRILLDOWN, C.COLOR_HEADER_COMMISSION_DRILLDOWN, 'todo');
          await addRadarSheet(C.SHEET_NAME_OTB_GM_MTD_ENTRY, C.SHEET_HEADER_OTB_GM_MTD_ENTRY, C.COLOR_HEADER_OTB_GM_MTD_ENTRY, 'todo');
          await addRadarSheet(C.SHEET_NAME_OTB_GM_BATCH_ENTRY, C.SHEET_HEADER_OTB_GM_BATCH_ENTRY, C.COLOR_HEADER_OTB_GM_BATCH_ENTRY, 'todo');
          await addRadarSheet(C.SHEET_NAME_OTB_GM_RECAP, C.SHEET_HEADER_OTB_GM_RECAP, C.COLOR_HEADER_OTB_GM_RECAP, 'todo');
          await addRadarSheet(C.SHEET_NAME_OTB_GM_SUMMARY, C.SHEET_HEADER_OTB_GM_SUMMARY, C.COLOR_HEADER_OTB_GM_SUMMARY, 'todo');
 
          await addHiddenSheet(C.SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY);


          await context.sync();
          loginProgress = LI_STATUS_SHEETS_ADDED;
          await navTo(C.NAV_DASHBOARD);
          await loadDashboard();
          loginProgress = LI_STATUS_DASHBOARD_LOADED;
          // const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_HOME);

          // clearSheet(context, C.SHEET_NAME_HOME);
          // ws.getRange("A1").values = [["Welcome to DECON Radar 3.0 - Your home away from home"]];
          // ws.getRange("A2").values = [["Logged in as " + connectionInfo.uid]];
          // // ws.getRange("A2").values = [[response.status]];
          // // ws.getRange("A3").values = [[response.statusText]];
          // ws.activate();
        } 
        else if(response.status === 401) { // unauthorized
          //Warn user
          // if (response.error === "Incorrect password)" {

          // }
          updateFooterStatus(`${new Date().toLocaleTimeString()} - ${data.error}`);
          // updateFooterStatus(data.error);

        }
        else { //other error
          //Warn user
          updateFooterStatus(`${new Date().toLocaleTimeString()} - ${data.error}`);
          // updateFooterStatus(data.error);
        
        }

      } catch (err) {
        switch (loginProgress) {
          case LI_STATUS_INITIATED:
            updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt failed to connect to server. Error: ${err.name} - ${err.message}`);
            break;
          case LI_STATUS_SUCCESS:
            updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt failed with error:  ${err.name} - ${err.message}`);
            break;
          case LI_STATUS_VARS_LOADED:
            updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt failed with error:  ${err.name} - ${err.message}`);
            break;
          case LI_STATUS_SHEETS_ADDED:
            updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt failed with error:  ${err.name} - ${err.message}`);
            break;
          case LI_STATUS_DASHBOARD_LOADED:
            updateFooterStatus(`${new Date().toLocaleTimeString()} - Login attempt failed with error:  ${err.name} - ${err.message}`);
            break;
        }
        updateFooterStatus(`${new Date().toLocaleTimeString()} - Please check your internet connection. If it's not you, it's probably the server. Please alert the appropriate parties if the issue persists!`);
      };

    });

}
async function logOut() {
  await Excel.run(async (context) => {
    updateFooterStatus("Logging out")     ;
    connectionInfo.logged_in = false;
    connectionInfo.uid = C.UID_WHEN_LOGGED_OUT;
    await clearLoadedVariables();

    document.getElementById("defcon-navigation").style.display = "none";   
    document.getElementById("defcon-nav-mini").style.display = "none";   
    
    await navTo(C.NAV_LOGIN);    

    clearFooterStatus();
    
    // Show a 'logged out' sheet with instructions on logging in
    await removeRadarSheets();

  });
}

async function removeRadarSheets() {
  await Excel.run(async (context) => {
    
    context.workbook.application.suspendScreenUpdatingUntilNextSync(); //to avoid blinking mess

    let list_sheets = [
        // C.SHEET_NAME_HOME
      C.SHEET_NAME_VS_ENTRY
      , C.SHEET_NAME_VS_MGR_REPORT
      , C.SHEET_NAME_VS_GP_DETAILS
      , C.SHEET_NAME_VS_LEADERBOARD
      , C.SHEET_NAME_FI_LEADERBOARD
      , C.SHEET_NAME_DAILY_SALES
      , C.SHEET_NAME_LEADERBOARD
      , C.SHEET_NAME_CIT
      , C.SHEET_NAME_COMMISSION_PAYROLL
      , C.SHEET_NAME_COMMISSION_DRILLDOWN
      , C.SHEET_NAME_OTB_GM_MTD_ENTRY
      , C.SHEET_NAME_OTB_GM_BATCH_ENTRY
      , C.SHEET_NAME_OTB_GM_RECAP
      , C.SHEET_NAME_OTB_GM_SUMMARY
      , C.SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY
    ]
    
    for (let sht in list_sheets) {
      let ws = context.workbook.worksheets.getItemOrNullObject(list_sheets[sht]);
      ws.load("isNullObject");
        await context.sync();  
      if (!ws.isNullObject) {
        ws.delete();
      } else {
        console.log(`Went to delete sheet ${list_sheets[sht]} but it didn't exist!`);
      }
    }

    await context.sync();
  })

}

async function addRadarSheet(sheetName, title, themeColor, associatedTab) {
  await Excel.run(async (context) => {
      
    let sheet = context.workbook.worksheets.getItemOrNullObject(sheetName);
    sheet.load("isNullObject");
    await context.sync();

    let ws;
    if (sheet.isNullObject) {
      context.workbook.worksheets.add(sheetName);
      ws = context.workbook.worksheets.getItem(sheetName);
    }
    else {
      clearSheet(context, sheetName);
      ws = context.workbook.worksheets.getItem(sheetName);
      // ws.activate();
    };


    // ws.activate();
    ws.getRange("A1").values = [[title]];
    ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;
    ws.getRange("A1").format.font.bold = true;
    ws.getRange("A1").format.font.color = C.COLOR_HEADER_FONT_DEFAULT;
    ws.getRange("1:1").format.fill.color = themeColor;

    ws.tabColor = themeColor;
    // tabColor	 - The tab color of the worksheet. When retrieving the tab color, if the worksheet is invisible, the value will be null. If the worksheet is visible but the tab color is set to auto, an empty string will be returned. Otherwise, the property will be set to a color, in the form #RRGGBB (e.g., "FFA500"). When setting the color, use an empty-string to set an "auto" color, or a real color otherwise.

  });
}

async function addHiddenSheet(sheetName) {
  await Excel.run(async (context) => {
    let sheet = context.workbook.worksheets.getItemOrNullObject(sheetName);
    sheet.load("isNullObject");
    await context.sync();
    if (sheet.isNullObject) {
      context.workbook.worksheets.add(sheetName);
      let ws = context.workbook.worksheets.getItem(sheetName);
      // ws.visibility = Excel.SheetVisibility.hidden;
    }
  });
}


async function loadOTBGMMTDReport() {
  await Excel.run(async (context) => {
    await clearSheet(context, C.SHEET_NAME_OTB_GM_MTD_ENTRY);
    
    
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_MTD_ENTRY);

    const inputDate = document.getElementById("otb-gm-mtd-date").value;
    const inputMonth = inputDate.substring(5);
    const inputYear = inputDate.substring(0, 4);
    
    const strDate = new Date(inputDate).toLocaleDateString("en-us", {timeZone: 'UTC', month: 'long', year: 'numeric'});

    const inputStore = document.getElementById("otb-gm-mtd-store").value;

    const reportDesc = `Showing OTB GM data for ${strDate} at store ${inputStore}`;
    
    // Add report title/info
    ws.getRange("A1").values = [[C.SHEET_HEADER_OTB_GM_MTD_ENTRY]];  // TODO magic number
    ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
    
    const response = await fetch(`${connectionInfo.hostName}getOTBGMMTDEntry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({inputStore: inputStore, inputMonth: inputMonth, inputYear : inputYear}),
    });

    const data = await response.json();
    
    const headers = Object.keys(data['report_body'][0]);
    const values = data['report_body'].map(item => Object.values(item));
    const dataToWrite = [headers, ...values];

    // 3. Define the target range (e.g., starting at A1)
    const startCell = ws.getRange("B4");  // TODO magic number

    // Get the resized range based on the data dimensions
    const endRow = dataToWrite.length - 1;
    const endColumn = dataToWrite[0].length - 1;
    const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
    
    const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
    range.values = dataToWrite;

    // //Apply formatting
    ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.bold = true;
    ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

    ws.getRange("A2").format.font.italic = true; // TODO magic number
    ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
    
    resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color

    resultTbl.columns.getItem("Today's Inventory Level").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Current Month Expected Delivery").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("MTD Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("MTD COGS").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Non-Moving Inventory").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
              
    // Add conditional formats
    const conditionalFormat = resultTbl.getDataBodyRange().conditionalFormats.add(
         Excel.ConditionalFormatType.custom
    );
    conditionalFormat.custom.rule.formula = '=IF($I5="Inactive",TRUE)'; // If the category is inactive, highlight the row // TODO magic number
    conditionalFormat.custom.format.fill.color = C.COLOR_COND_FORMAT_ATTENTION;


    resultTbl.getDataBodyRange().format.autofitColumns();
    resultTbl.getDataBodyRange().format.autofitRows();

    ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;

    
    // Freeze the specified range in top-and-left-most pane of the worksheet.
    ws.freezePanes.freezeAt(ws.getRange("1:4"));  // TODO magic number
    
    //Add the loaded report's status values
    document.getElementById("otb-gm-mtd-date-updated").value = data["report_header"][0].date_updated;
    document.getElementById("otb-gm-mtd-days-completed").value =  data["report_header"][0].business_days_completed;
    document.getElementById("otb-gm-mtd-days-in-month").value = data["report_header"][0].business_days_in_month;
    document.getElementById("otb-gm-mtd-status").value = data["report_header"][0].status;    
    document.getElementById("otb-gm-mtd-g-id").value = data["report_header"][0].id;    
    
    // Reveal the loaded report's status div
    document.getElementById("otb-gm-mtd-report-status").style.display = "grid";

    ws.activate(); // Show the results

    context.sync();
  });
}

async function saveOTBGMMTDReport() {
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_MTD_ENTRY);
    await context.sync();      

    let dateToday = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

    const repID = document.getElementById("otb-gm-mtd-g-id").value;
    const repStatus = document.getElementById("otb-gm-mtd-status").value;
    const repDateUpdated = dateToday;
    const repBDComplete = document.getElementById("otb-gm-mtd-days-completed").value;
    const repBDInMonth = document.getElementById("otb-gm-mtd-days-in-month").value;
    // document.getElementById("otb-gm-mtd-days-in-month").value = 1;
    
    let repTable = ws.tables.getItemAt(0); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name

    let bodyRange = repTable.getDataBodyRange().load("values");

    await context.sync();    // Sync to populate properties that need to be loaded

    let reportRows = bodyRange.values;
    
    const response = await fetch(`${connectionInfo.hostName}saveOTBGMMTDEntry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
          repID : repID
        , repStatus : repStatus
        , repDateUpdated : repDateUpdated
        , repBDComplete : repBDComplete
        , repBDInMonth : repBDInMonth
        , reportRows : reportRows
      }),
    }); 
    
    const data = await response.json();
    
  
    if(response.status === 200) { // OK
      updateFooterStatus(`${new Date().toLocaleTimeString()} - OTB data updated successfully`);
      
      document.getElementById("otb-gm-mtd-date-updated").value = repDateUpdated; // Update the date updated field on the sheet to reflect the save

    }
    else {
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Failed to update OTB data: ${data.error}. Please confirm that all required fields are filled out and try again. If the issue persists, please contact the appropriate parties.`);
    
    };


  });
}


async function loadOTBGMCategoryReport() {
//TODO 
  await Excel.run(async (context) => {
    
    context.sync();
  });
}


async function updateOTBGMCatCategoryList() {
// Fired as an event handler on the store dropdown in the OTB GM by Category report form, updates the category dropdown based on the selected store
// Also called when the form is loaded to populate the category dropdown for the default selected store

    await Excel.run(async (context) => {
      let store = document.getElementById("otb-gm-cat-store").value;

      let cats = [];
      opts["otbCategoriesByStore"].forEach((item) => {
        if (item.store == store) {
          cats.push(item.category_display_name_full);
        }
      });

      document.getElementById("otb-gm-cat-category").innerHTML = cats.map(cat => `<option value="${cat}">${cat}</option>`).join(""); //THIS IS THE GOOd, BASIC NONDYNAMIC VERSION

  });
}
async function updateOTBGMCatGroupList() {
// Fired as an event handler on the store dropdown in the OTB GM by group report form, updates the group dropdown based on the selected store
// Also called when the form is loaded to populate the group dropdown for the default selected store

    await Excel.run(async (context) => {
      let store = document.getElementById("otb-gm-group-store").value;

      let cats = [];
      opts["otbCategoriesByStore"].forEach((item) => {
        if (item.store == store) {
          cats.push(item.category_display_name_full);
        }
      });

      document.getElementById("otb-gm-cat-category").innerHTML = cats.map(cat => `<option value="${cat}">${cat}</option>`).join(""); //THIS IS THE GOOd, BASIC NONDYNAMIC VERSION

  });
}

async function loadOTBGMSummaryReport() {
  await Excel.run(async (context) => {
    await clearSheet(context, C.SHEET_NAME_OTB_GM_SUMMARY);
    
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_SUMMARY);

    const inputDate = document.getElementById("otb-gm-sum-date").value;
    const inputMonth = inputDate.substring(5);
    const inputYear = inputDate.substring(0, 4);
    
    const strDate = new Date(inputDate).toLocaleDateString("en-us", {timeZone: 'UTC', month: 'long', year: 'numeric'});

    const inputStore = document.getElementById("otb-gm-sum-store").value;

    const reportDesc = `Showing OTB GM Summary for ${strDate} at store ${inputStore}`;
    
    // Add report title/info
    ws.getRange("A1").values = [[C.SHEET_HEADER_OTB_GM_SUMMARY]];  // TODO magic number
    ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
    
    const response = await fetch(`${connectionInfo.hostName}getOTBGMSummary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({inputStore: inputStore, inputMonth: inputMonth, inputYear : inputYear}),
    });

    const data = await response.json();
    
    const headers = Object.keys(data['report_body'][0]);
    const values = data['report_body'].map(item => Object.values(item));
    const dataToWrite = [headers, ...values];
 
    // 3. Define the target range (e.g., starting at A1)
    const startCell = ws.getRange("B4");  // TODO magic number

    // Get the resized range based on the data dimensions
    const endRow = dataToWrite.length - 1;
    const endColumn = dataToWrite[0].length - 1;
    const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
    
    const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
    range.values = dataToWrite;

    // //Apply formatting
    ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.bold = true;
    ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

    ws.getRange("A2").format.font.italic = true; // TODO magic number
    ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
    
    resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color

    resultTbl.columns.getItem("Open to Buy - To Begin Next Month").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    
    // Add conditional formats -- TODO figure out which column categoory status is in
    // const conditionalFormat = resultTbl.getDataBodyRange().conditionalFormats.add(
    //      Excel.ConditionalFormatType.custom
    // );
    // conditionalFormat.custom.rule.formula = '=IF($I5="Inactive",TRUE)'; // If the category is inactive, highlight the row // TODO magic number
    // conditionalFormat.custom.format.fill.color = C.COLOR_COND_FORMAT_ATTENTION;

    resultTbl.getDataBodyRange().format.autofitColumns();
    resultTbl.getDataBodyRange().format.autofitRows();

    ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;
    
    // Freeze the specified range in top-and-left-most pane of the worksheet.
    ws.freezePanes.freezeAt(ws.getRange("1:4"));  // TODO magic number

    // Hide helper data columns 
    ws.getRange("E:S").columnHidden = true;
    
    ws.activate(); // Show the results
    ws.getRange("B5").select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring
    // ws.getRange("B5").activate();

    context.sync();
  });
}

async function loadOTBGMRecapReport() { 
  await Excel.run(async (context) => {
    await clearSheet(context, C.SHEET_NAME_OTB_GM_RECAP);
    
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_RECAP);

    const inputDate = document.getElementById("otb-gm-recap-date").value;
    const inputMonth = inputDate.substring(5);
    const inputYear = inputDate.substring(0, 4);
    
    const strDate = new Date(inputDate).toLocaleDateString("en-us", {timeZone: 'UTC', month: 'long', year: 'numeric'});

    const inputStore = document.getElementById("otb-gm-recap-store").value;

    const reportDesc = `Showing OTB GM Recap Report for ${strDate} at store ${inputStore}`;
    
    // Add report title/info
    ws.getRange("A1").values = [[C.SHEET_HEADER_OTB_GM_RECAP]];  // TODO magic number
    ws.getRange("A2").values = [[reportDesc]];  // TODO magic number
    
    const response = await fetch(`${connectionInfo.hostName}getOTBGMRecap`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({inputStore: inputStore, inputMonth: inputMonth, inputYear : inputYear}),
    });

    const data = await response.json();
    
    const headers = Object.keys(data['report_body'][0]);
    const values = data['report_body'].map(item => Object.values(item));

    // //TEMP proof of concept
    // const headers = ["Category", "Description", "Current Month Actual Sales", "Current Month End Trending Sales", "Previous Year Month End Sales", "+/-", "Projected Month End Sales", "+/- ", "Current Margin", "Projected Margin", "+/-  ", "Current Inventory", "EOM Inventory Target", "Open to Buy - To Begin Next Month"]
    // const values = ["AM", "Small Accessories - Men", 387.30, 1006.98, 1482.39, -475.41, 1556.51, -549.53, .31, .48, -.17, 5116.15, 5094.14, -777.81]
    
    const dataToWrite = [headers, ...values];
 
    // 3. Define the target range (e.g., starting at A1)
    const startCell = ws.getRange("B4");  // TODO magic number

    // Get the resized range based on the data dimensions
    const endRow = dataToWrite.length - 1;
    const endColumn = dataToWrite[0].length - 1;
    const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
    
    const resultTbl = ws.tables.add(range, true /*hasHeaders*/);
    range.values = dataToWrite;

    // //Apply formatting
    ws.getRange("1:1").format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color
    ws.getRange("1:1").format.font.bold = true;
    ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

    ws.getRange("A2").format.font.italic = true; // TODO magic number
    ws.getRange("2:2").format.font.color = C.COLOR_HEADER_FILL_STANDARD;  //TODO magic number AND color
    
    resultTbl.getHeaderRowRange().format.fill.color = C.COLOR_HEADER_FILL_STANDARD; //TODO magic color
    resultTbl.getHeaderRowRange().format.font.color = C.COLOR_HEADER_FONT_STANDARD; //TODO magic color

    resultTbl.columns.getItem("Current Month Actual Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Current Month End Trending Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Previous Year Month End Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("delta1").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Projected Month End Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("delta2").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Current Inventory").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("EOM Inventory Target").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    resultTbl.columns.getItem("Open to Buy - To Begin Next Month").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];

    resultTbl.columns.getItem("Current Margin").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
    resultTbl.columns.getItem("Projected Margin").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
    resultTbl.columns.getItem("delta3").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];

    // If the change between CY Trending Sales and PY month end sales is negative/positive
    let condFormatDelta1 = resultTbl.columns.getItem("delta1").getDataBodyRange().conditionalFormats.add(
      Excel.ConditionalFormatType.cellValue
    );
    condFormatDelta1.cellValue.rule = {
      formula1: "0",
      operator: Excel.ConditionalCellValueOperator.lessThan
    };
    condFormatDelta1.cellValue.format.fill.color = C.COLOR_COND_FORMAT_NEGATIVE;
    
    // If the change between CY Projected Sales and PY month end sales is negative/positive
    let condFormatDelta2 = resultTbl.columns.getItem("delta2").getDataBodyRange().conditionalFormats.add(
      Excel.ConditionalFormatType.cellValue
    );
    condFormatDelta2.cellValue.rule = {
      formula1: "0",
      operator: Excel.ConditionalCellValueOperator.lessThan
    };
    condFormatDelta2.cellValue.format.fill.color = C.COLOR_COND_FORMAT_NEGATIVE;

    // If Open to Buy is negative/positive
    let condFormatOTB = resultTbl.columns.getItem("Open to Buy - To Begin Next Month").getDataBodyRange().conditionalFormats.add(
      Excel.ConditionalFormatType.cellValue
    );
    condFormatOTB.cellValue.rule = {
      formula1: "0",
      operator: Excel.ConditionalCellValueOperator.lessThan
    };
    condFormatOTB.cellValue.format.fill.color = C.COLOR_COND_FORMAT_NEGATIVE;

    ws.getRange("4:4").format.rowHeight = C.ROW_HEIGHT_TBL_HEADER_DOUBLE; // Set the header row height to be taller to accommodate wrapped text, then set the data rows to a minimum height to ensure readability of wrapped text, then autofit to content up to a max height
    ws.getRange("4:4").format.wrapText = true;
    
    resultTbl.getDataBodyRange().format.columnWidth = C.COL_WIDTH_TBL_MIN_REPORT; // Set all data columns to a minimum width to ensure readability of wrapped text, then autofit to content up to a max width
    
    resultTbl.getDataBodyRange().format.autofitColumns();
    resultTbl.getDataBodyRange().format.autofitRows();

    ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;
    
    // Freeze the specified range in top-and-left-most pane of the worksheet.
    ws.freezePanes.freezeAt(ws.getRange("1:4"));  // TODO magic number

    // // Hide helper data columns 
    // ws.getRange("E:S").columnHidden = true;
    
    ws.activate(); // Show the results
    ws.getRange("B5").select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring
    // ws.getRange("B5").activate();

    context.sync();
  });
}

function getProjFieldFromDisplayName(displayName) {
  let projField = "";
  opts["otbBatchProjFieldsDisplayNames"].forEach((item) => {
    if (item.display_name == displayName) {
      projField = item.field;
    }
  });
  return projField;
}

function getProjNumFormatFromDisplayName(displayName) {
  let projField = "";
  opts["otbBatchProjFieldsDisplayNames"].forEach((item) => {
    if (item.display_name == displayName) {
      projField = item.number_format;
    }
  });
  return projField;
}

async function addDataTable(context, ws, data, startCellAddress, tblName = null) {
  await Excel.run(async (context) => {
    
    const startCell = ws.getRange(startCellAddress);  // TODO magic number

    // Get the resized range based on the data dimensions
    const endRow = data.length - 1;
    const endColumn = data[0].length - 1;
    const range = startCell.getResizedRange(endRow, endColumn); // Resizes the range to fit the data
    
    let resultTbl = ws.tables.add(range, true /*hasHeaders*/);
    range.values = data;

    // let headerRange =  startCell.getResizedRange(0, endColumn); 
    // headerRange.values = [['a', 'b', 'c', 'March 2024','e','f','g','h','i']]

    if( tblName !== null ) {
      resultTbl.name = tblName;
    }

    // return resultTbl.name;
  });
};

async function queryStandardRadarReport(postAddress, inputBody, resultSheetName, resultAddress) {
  await Excel.run(async (context) => {
    console.log(`Calling ${postAddress}()`)

    const response = await fetch(`${connectionInfo.hostName}${postAddress}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: inputBody,
    });
      // console.log('error here?')
    const data = await response.json();
    console.log('data received')

    if(response.status === 200) { // OK
      

      if(data['report_body'].length == 0) {
        updateFooterStatus(`${new Date().toLocaleTimeString()} - No data to display for the selected report parameters. Please adjust the parameters and try again.`);
        return { status: "no_data" };
      }
      else {
        const headers = Object.keys(data['report_body'][0]); 
        const values = data['report_body'].map(item => Object.values(item));

        const dataToWrite = [headers, ...values];
        const ws = context.workbook.worksheets.getItem(resultSheetName);    
        context.sync();
        await addDataTable(context, ws, dataToWrite, resultAddress);
        updateFooterStatus(`${new Date().toLocaleTimeString()} -  sending data back to caller...`);
        // console.log( {"status": "success", "data": data['report_body']})
        return {"status": "success", "data": data['report_body']};
      }
      
    } else if(response.status === 500) { // server error
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Server error while running report: ${data.error}. Please try again. If the issue persists, please contact the appropriate parties.`);
      return { status: "server_error" };
    } else if(response.status === 407) { // no data for report parameters
      updateFooterStatus(`${new Date().toLocaleTimeString()} - No data to display for the selected report parameters. Please adjust the parameters and try again.`);
      return { status: "no_data" };
    }
    
  });
}

async function formatStandardRadarReport(context, ws, resultTbls, reportTitle, reportDesc, color_headers_fill, color_headers_font, color_secondary_fill, color_secondary_font, freezeAtAddress, headerRows : []) {
  

    // Add report title/info
    ws.getRange("A1").values = [[reportTitle]];  // TODO magic number
    ws.getRange("A2").values = [[reportDesc]];  // TODO magic number

   
    // //Apply formatting
    ws.getRange("1:1").format.fill.color = color_headers_fill;
    ws.getRange("1:1").format.font.color = color_headers_font;
    ws.getRange("1:1").format.font.bold = true;
    ws.getRange("A1").format.font.size = C.FONT_SIZE_TITLE;

    ws.getRange("A2").format.font.italic = true; // TODO magic number
    ws.getRange("2:2").format.fill.color = color_secondary_fill;
    ws.getRange("2:2").format.font.color = color_secondary_font;
    
    for (let i = 0; i < resultTbls.length; i++) {
        
      resultTbls[i].getHeaderRowRange().format.fill.color = color_headers_fill
      resultTbls[i].getHeaderRowRange().format.font.color = color_headers_font; 
      
      resultTbls[i].getDataBodyRange().format.columnWidth = C.COL_WIDTH_TBL_MIN_REPORT; // Set all data columns to a minimum width to ensure readability of wrapped text, then autofit to content up to a max width   

      resultTbls[i].getDataBodyRange().format.autofitColumns();
      resultTbls[i].getDataBodyRange().format.autofitRows();
    }

    ws.getRange("A:A").format.columnWidth = C.COL_WIDTH_LEFT;

    // Freeze the specified range in top-and-left-most pane of the worksheet.
    if (freezeAtAddress !== "") { 
      ws.freezePanes.freezeAt(ws.getRange(freezeAtAddress));  // TODO magic number
    };

    for (let i = 0; i < headerRows.length; i++) {
      ws.getRange(`${headerRows[i]}:${headerRows[i]}`).format.rowHeight = C.ROW_HEIGHT_TBL_HEADER_DOUBLE; // Set the header row height to be taller to accommodate wrapped text, then set the data rows to a minimum height to ensure readability of wrapped text, then autofit to content up to a max height
      ws.getRange(`${headerRows[i]}:${headerRows[i]}`).format.wrapText = true;
      // ws.getRange(header).format.fill.color = color_headers_fill;
      ws.getRange(`${headerRows[i]}:${headerRows[i]}`).format.font.color = color_headers_font;
      ws.getRange(`${headerRows[i]}:${headerRows[i]}`).format.font.bold = true;
    };    
};


async function loadOTBGMBatchReport() { 
  await Excel.run(async (context) => {
    const TBL_START_CELL = "B4"; 
    const MONTH_DISPLAY_START_CELL = "E3";
  
    await clearSheet(context, C.SHEET_NAME_OTB_GM_BATCH_ENTRY);
    await clearSheet(context, C.SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY);
        
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_BATCH_ENTRY);
    const wsChangeTracker = context.workbook.worksheets.getItem(C.SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY);

    const inputStore = document.getElementById("otb-gm-batch-store").value;
    const inputStartDate = document.getElementById("otb-gm-batch-date").value;
    const inputProjField = document.getElementById("otb-gm-batch-proj-field").value;
    const inputProjNumMonths = parseInt(document.getElementById("otb-gm-batch-proj-num-months").value);

    const startMonth = parseInt(inputStartDate.substring(5, 7));
    const startYear = parseInt(inputStartDate.substring(0, 4));

    let projField = getProjFieldFromDisplayName(inputProjField);
    let projFieldNumFormat = getProjNumFormatFromDisplayName(inputProjField);
    
    let endMonth = parseInt(startMonth) + inputProjNumMonths -1;
    let endYear = parseInt(startYear);
    if(endMonth > 12) {
      endYear += Math.floor((endMonth - 1) / 12);
      endMonth = ((endMonth - 1) % 12) + 1;
    } // Manually calculate the end month and year based on the start month/year and the number of months to project, accounting for year rollover.
    
    
    const reportDesc = `Showing ${inputProjField} values for ${inputProjNumMonths} months at store ${inputStore}`;

    let inputBody =  JSON.stringify({
        store: inputStore, startMonth: startMonth, startYear : startYear
      , endMonth : endMonth, endYear : endYear
      , projField : projField
    });

    let result = await queryStandardRadarReport('getOTBGMBatchEntry', inputBody, C.SHEET_NAME_OTB_GM_BATCH_ENTRY, TBL_START_CELL)
    
    // if(result.status !== "success") {
    //   return; // If the report data failed to load, exit the function to avoid trying to format and manipulate a table that doesn't exist
    // }

    // The table renamed our date columns regardless of how we formatted them. So for now calling them Month 1 to Month X
    // Display workaround: show names in row above the data table
    let monthNames = [];
    for (let i = 0; i < inputProjNumMonths; i++) {
        let month = (startMonth + i) % 12 || 12; // wrap around to 1 after December
        let year = startYear + Math.floor((startMonth + i - 1) / 12); // increment year after December  
        monthNames.push(`${month}/${year}`);
    };
    let firstMonthCell = ws.getRange(MONTH_DISPLAY_START_CELL);
    const monthDisplayRange = firstMonthCell.getResizedRange(0, inputProjNumMonths-1); // Resizes the range to fit the data
    monthDisplayRange.values = [monthNames];
    
    let resultTbl = ws.tables.getItemAt(0); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name
    
    await context.sync();

    // Create a data tabe in the hidden_gm_batch_entry sheet so we can track the changes being made by the user
    const range = resultTbl.getRange();
    range.load('values');
    await context.sync();
    await addDataTable(context, wsChangeTracker, range.values, TBL_START_CELL);
      
    await formatStandardRadarReport(context, ws, [resultTbl], C.SHEET_NAME_OTB_GM_BATCH_ENTRY, reportDesc, C.COLOR_HEADER_OTB_GM_BATCH_ENTRY, C.COLOR_HEADER_FONT_OTB_GM_BATCH_ENTRY, "#FFFFFF", C.COLOR_HARLEY_BLACK, "A1:C4", [4]);
    
    // Custom formats for this report
    monthDisplayRange.format.fill.color = C.COLOR_HEADER_OTB_GM_BATCH_ENTRY;  //TODO magic number 
    monthDisplayRange.format.font.color = '#FFFFFF';
    monthDisplayRange.format.font.bold = true; 
    
    // Taskpane loaded report info    
    document.getElementById("otb-gm-batch-loaded-proj-field").value = projField;
    document.getElementById("otb-gm-batch-loaded-store").value =  inputStore;
    document.getElementById("otb-gm-batch-loaded-month").value = startMonth;
    document.getElementById("otb-gm-batch-loaded-year").value = startYear;
    document.getElementById("otb-gm-batch-loaded-num-months").value = parseInt(inputProjNumMonths);
    
    document.getElementById("otb-gm-batch-report-status").style.display = "grid"; // Reveal the report status div which contains the save button and last updated info
    
    resultTbl.getDataBodyRange().numberFormat = [[projFieldNumFormat]]; // Set the number format for all data body columns to the appropriate format for the projected field

    ws.activate(); // Show the results
    ws.getRange("B5").select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring

    await context.sync();
  });
}

async function saveOTBGMBatchReport() {
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_OTB_GM_BATCH_ENTRY);
    await context.sync();      

    let numMonths = parseInt(document.getElementById("otb-gm-batch-loaded-num-months").value);
    let projField = document.getElementById("otb-gm-batch-loaded-proj-field").value;
    let store = document.getElementById("otb-gm-batch-loaded-store").value;
    let startMonth = parseInt(document.getElementById("otb-gm-batch-loaded-month").value);
    let startYear = parseInt(document.getElementById("otb-gm-batch-loaded-year").value);

    let tblOriginal = context.workbook.worksheets.getItem(C.SHEET_NAME_HIDDEN_OTB_GM_BATCH_ENTRY).tables.getItemAt(0); // Get the original table that was loaded with the report data, which is hidden from the user but serves as a reference for what the original data looked like when it was loaded. This allows us to compare the current table to the original and determine what changes were made by the user, which we can then send to the backend to update the DB accordingly.
    let tblCurrent = ws.tables.getItemAt(0); // Get the current table that is visible to the user and may have been edited
    
    let batchData = [];
    let categoryRange = tblOriginal.columns.getItem("Category").getDataBodyRange().load("values"); // will get loaded once the first month's await context.sync() is called, so we can use it for all month comparisons without needing to load it multiple times
    
    // Loop through each month's data and update the relevant records in the DB
    for (let monthI = 1; monthI <= parseInt(numMonths); monthI++) {
      let month = startMonth + monthI - 1;
      let year = startYear + Math.floor((monthI - 1) / 12);
      
      let originalRange = tblOriginal.columns.getItem(`Month ${monthI}`).getDataBodyRange().load("values");
      let currentRange = tblCurrent.columns.getItem(`Month ${monthI}`).getDataBodyRange().load("values");
      await context.sync(); // Sync to populate the values of the ranges

      for (let rowI = 0; rowI < originalRange.values.length; rowI++) {
        let originalValue = originalRange.values[rowI][0];
        let currentValue = currentRange.values[rowI][0];
        if (originalValue !== currentValue) { // If the value has been changed by the user
          batchData.push({
            category: categoryRange.values[rowI][0],
            month: month,
            year: year,
            originalValue: originalValue,
            newValue: currentValue
          });
        }

      };
    };
    console.log(batchData);

    if(batchData.length > 0) {
      const response = await fetch(`${connectionInfo.hostName}saveOTBGMBatchEntry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          batchData : batchData
          , startMonth : startMonth
          , startYear : startYear
          , projField : projField
          , store : store
        }),
      }); 
      const data = await response.json();   
    
      if(response.status === 200) { // OK
        updateFooterStatus(`${new Date().toLocaleTimeString()} - OTB data updated successfully`);
        
        // update the hidden excel table to match the frontend one
        
        const newOldValues = tblCurrent.getDataBodyRange();
        newOldValues.load('values')
        await context.sync();
      
        console.log(newOldValues.values);
        
        tblOriginal.getDataBodyRange().values = newOldValues.values;
        await context.sync();  

        // clearOTBGMBatchReport();
      }
      else {
        updateFooterStatus(`${new Date().toLocaleTimeString()} - Failed to update OTB data: ${data.error}. Please confirm that all required fields are filled out and try again. If the issue persists, please contact the appropriate parties.`);
      };   
    } else {
      updateFooterStatus(`${new Date().toLocaleTimeString()} - no changes detected!` );
    }

  });
}

function clearDailySalesReportTaskpane() {
        // Taskpane loaded report info    
      document.getElementById("dsu-loaded-date").textContent = "";
      document.getElementById("dsu-loaded-store").textContent = "";
      document.getElementById("dsu-loaded-dept").textContent = "";
      document.getElementById("dsu-sales-daily-total").value = 0;
      document.getElementById("dsu-sales-daily-ass").value = 0;
      document.getElementById("dsu-sales-daily-unass").value = 0;
      document.getElementById("dsu-sales-mtd").value = 0;      
      
      document.getElementById("dsu-report-status-div").style.display = "none";
      
}
async function loadDailySalesReport() { 
  await Excel.run(async (context) => {
    const TBL_START_CELL = "B4"; 
    
    clearDailySalesReportTaskpane(); // Clear the taskpane of any info from a previously loaded report
    await clearSheet(context, C.SHEET_NAME_DAILY_SALES);
        
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_DAILY_SALES);
    
    const inputDate = document.getElementById("dsu-date").value;
    const inputStore = document.getElementById("dsu-store").value;  
    const inputDept = document.getElementById("dsu-dept").value;
    const reportDesc = `Showing ${inputDept} Daily Sales for ${inputDate} at store ${inputStore}`;
    
    let inputBody =  JSON.stringify({
        uid : connectionInfo.uid
      , inputDate : inputDate
      , inputStore : inputStore
      , inputDept : inputDept
    });

    let result = await queryStandardRadarReport('getDailySalesReport', inputBody, C.SHEET_NAME_DAILY_SALES, TBL_START_CELL)
    // console.log(result)
    // if(result.status == 'success' || true) {
    if(true) {
      
      // console.log(result.data)
      let resultTbl = null;
      try {
        resultTbl = ws.tables.getItemAt(0); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name
      } catch (error) {
        console.error("Error getting the result table:", error);
      
      }

      if( resultTbl == null) {
      }
      else{
      
        await context.sync();

        // // Create a data tabe in the hidden_gm_batch_entry sheet so we can track the changes being made by the user
        // const range = resultTbl.getRange();
        // range.load('values');
        // await context.sync();
        // await addDataTable(context, wsChangeTracker, range.values, TBL_START_CELL);
          
        //Number formats and formulas
        const rowCount = resultTbl.rows.getCount();  
      
        
        await context.sync();
        let numRows = rowCount.value;
        
        resultTbl.columns.getItem("ID").getDataBodyRange().format.horizontalAlignment = "Center";
        
        switch (inputDept) {
          case "General Merchandise": //these 3 departments share the same fields so they can be grouped together like this. Mind the 'break'.
          case "Parts OTC":
          case "Online":
            resultTbl.columns.getItem("Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Margin").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
            
            let formulasMargin = [];
            for(let i=0; i<numRows; i++) {
              formulasMargin.push([`=IFERROR([@GP]/[@Sales], 0)`]);
            }
            resultTbl.columns.getItem("Margin").getDataBodyRange().formulas = formulasMargin;

            break;

          case "Service":        
            resultTbl.columns.getItem("Labor Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Parts to WO Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Parts to Labor").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
            resultTbl.columns.getItem("Total Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            
            let formulasRatio = [];
            let formulasTotalSales = [];
            for(let i=0; i<numRows; i++) {
              formulasRatio.push([`=IFERROR([@[Parts to WO Sales]]/[@[Labor Sales]], 0)`]);
              formulasTotalSales.push([`=IFERROR([@[Labor Sales]]+[@[Parts to WO Sales]], 0)`]);
            }
            resultTbl.columns.getItem("Parts to Labor").getDataBodyRange().formulas = formulasRatio;
            resultTbl.columns.getItem("Total Sales").getDataBodyRange().formulas = formulasTotalSales;

            break;

          case "Technician":
            resultTbl.columns.getItem("Efficiency").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];        
            
            let formulasEfficiency = [];
            for(let i=0; i<numRows; i++) {
              formulasEfficiency.push([`=IFERROR(([@[Billed Hours]]/[@[Clocked Hours]]), 0)"]);`]);
            }
            resultTbl.columns.getItem("Efficiency").getDataBodyRange().formulas = formulasEfficiency;

            break;
        };
        await context.sync();

        await formatStandardRadarReport(context, ws, [resultTbl], C.SHEET_NAME_DAILY_SALES, reportDesc, C.COLOR_HEADER_DAILY_SALES, C.COLOR_HEADER_FONT_DAILY_SALES, "#FFFFFF", C.COLOR_HARLEY_BLACK, `A1:${TBL_START_CELL}`, [4]);
      }
      
      
      // Taskpane loaded report info    
      document.getElementById("dsu-loaded-date").value = `${inputDate}`;
      document.getElementById("dsu-loaded-store").value = `${inputStore}`;
      document.getElementById("dsu-loaded-dept").value = `${inputDept}`;

      document.getElementById("dsu-report-status-div").style.display = "grid"; // Reveal the report status div which contains the save button and last updated info

      // resultTbl.getDataBodyRange().numberFormat = [[projFieldNumFormat]]; // Set the number format for all data body columns to the appropriate format for the projected field
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Daily Sales Leaderboard loaded successfully`);
    }
    else {
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Failed to load Daily Sales Leaderboard.`);
    }

    ws.activate(); // Show the results
    ws.getRange(TBL_START_CELL).select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring

    await context.sync();
  });
}

async function updateDSUSalesTotals() { // Whenever the user updates either the employees' daily sales or the storewide Total Daily Sales, update the assigned/unassigned and MTD totals accordingly.
  //async because it can be called from either changing the HTML input field or from changes in the excel table
  let totalDailySales = parseFloat(document.getElementById("dsu-sales-daily-total").value) || 0; // Get the total daily sales input by the user, or default to 0 if the input is empty or invalid
  let assignedSales = 123.45;
  let unassignedSales = totalDailySales - assignedSales;
  let mtdSales = 6789.01;

  document.getElementById("dsu-sales-daily-ass").value = +assignedSales.toFixed(2); // + converts back to number after toFixed converst to string
  document.getElementById("dsu-sales-daily-unass").value = +unassignedSales.toFixed(2); // + converts back to number after toFixed converst to string
  document.getElementById("dsu-sales-mtd").value = +mtdSales.toFixed(2); // + converts back to number after toFixed converst to string

}

async function registerTableChangeListener() {
    await Excel.run(async (context) => {
        // Retrieve the active worksheet and the specific table
        const sheet = context.workbook.worksheets.getActiveWorksheet();
        const table = sheet.tables.getItem("MyTableName");

        // Subscribe to the onChanged event
        table.onChanged.add(onTableChanged);

        await context.sync();
        console.log("Event listener registered successfully.");
    });
}

async function onDSUTableChange(eventArgs: Excel.TableChangedEventArgs) {
    await Excel.run(async (context) => {
      //TODO DOES NOT WORK AS WRITTEN - table won't always exist, right? so need to maybe add listener when table is loaded, or change listener to entire sheet and then narrow in from changes there.....
        // Prevent event loops if you are making changes back to Excel
        context.runtime.enableEvents = false;

        // Retrieve specific change details
        const changedAddress = eventArgs.address;
        const tableId = eventArgs.tableId;

        console.log(`Cell ${changedAddress} changed in table ${tableId}`);

        // Call your UI update function (defined in your frontend framework)
        // updateTaskPaneUI(changedAddress); 

        await context.sync();
        context.runtime.enableEvents = true;
    });
}

//submit-dsu-report
async function saveDailySalesReport() { 
  await Excel.run(async (context) => {

    let inputDate = document.getElementById("dsu-loaded-date").textContent;
    let inputStore = document.getElementById("dsu-loaded-store").textContent;  
    let inputDept = document.getElementById("dsu-loaded-dept").textContent;

    let ws = context.workbook.worksheets.getItem(C.SHEET_NAME_DAILY_SALES);
    await context.sync(); 
    let resultTbl = ws.tables.getItemAt(0); 
    await context.sync(); 
    let range = resultTbl.getDataBodyRange().load("values");
    await context.sync();
      let dataToSave = range.values.map(row => {
        let rowData = {};
        resultTbl.columns.items.forEach((col, index) => {
          rowData[col.name] = row[index];
        });
        return rowData;
      });
    
    console.log(dataToSave);

    // const TBL_START_CELL = "B4"; 
    
    // clearDailySalesReportTaskpane(); // Clear the taskpane of any info from a previously loaded report
    // await clearSheet(context, C.SHEET_NAME_DAILY_SALES);
        
    // const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_DAILY_SALES);
    
    // const inputDate = document.getElementById("dsu-date").value;
    // const inputStore = document.getElementById("dsu-store").value;  
    // const inputDept = document.getElementById("dsu-dept").value;
    // const reportDesc = `Showing ${inputDept} Daily Sales for ${inputDate} at store ${inputStore}`;
    
    // let inputBody =  JSON.stringify({
    //     uid : connectionInfo.uid
    //   , inputDate : inputDate
    //   , inputStore : inputStore
    //   , inputDept : inputDept
    // });

    // let result = await queryStandardRadarReport('getDailySalesReport', inputBody, C.SHEET_NAME_DAILY_SALES, TBL_START_CELL)
    // // console.log(result)
    // // if(result.status == 'success' || true) {
    // if(true) {
      
    //   // console.log(result.data)
    //   let resultTbl = null;
    //   try {
    //     resultTbl = ws.tables.getItemAt(0); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name
    //   } catch (error) {
    //     console.error("Error getting the result table:", error);
      
    //   }

    //   if( resultTbl == null) {
    //   }
    //   else{
      
    //     await context.sync();

    //     // // Create a data tabe in the hidden_gm_batch_entry sheet so we can track the changes being made by the user
    //     // const range = resultTbl.getRange();
    //     // range.load('values');
    //     // await context.sync();
    //     // await addDataTable(context, wsChangeTracker, range.values, TBL_START_CELL);
          
    //     //Number formats and formulas
    //     const rowCount = resultTbl.rows.getCount();  
      
        
    //     await context.sync();
    //     let numRows = rowCount.value;
        
    //     resultTbl.columns.getItem("ID").getDataBodyRange().format.horizontalAlignment = "Center";
        
    //     switch (inputDept) {
    //       case "General Merchandise": //these 3 departments share the same fields so they can be grouped together like this. Mind the 'break'.
    //       case "Parts OTC":
    //       case "Online":
    //         resultTbl.columns.getItem("Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    //         resultTbl.columns.getItem("GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    //         resultTbl.columns.getItem("Margin").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
            
    //         let formulasMargin = [];
    //         for(let i=0; i<numRows; i++) {
    //           formulasMargin.push([`=IFERROR([@GP]/[@Sales], 0)`]);
    //         }
    //         resultTbl.columns.getItem("Margin").getDataBodyRange().formulas = formulasMargin;

    //         break;

    //       case "Service":        
    //         resultTbl.columns.getItem("Labor Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    //         resultTbl.columns.getItem("Parts to WO Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
    //         resultTbl.columns.getItem("Parts to Labor").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
    //         resultTbl.columns.getItem("Total Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            
    //         let formulasRatio = [];
    //         let formulasTotalSales = [];
    //         for(let i=0; i<numRows; i++) {
    //           formulasRatio.push([`=IFERROR([@[Parts to WO Sales]]/[@[Labor Sales]], 0)`]);
    //           formulasTotalSales.push([`=IFERROR([@[Labor Sales]]+[@[Parts to WO Sales]], 0)`]);
    //         }
    //         resultTbl.columns.getItem("Parts to Labor").getDataBodyRange().formulas = formulasRatio;
    //         resultTbl.columns.getItem("Total Sales").getDataBodyRange().formulas = formulasTotalSales;

    //         break;

    //       case "Technician":
    //         resultTbl.columns.getItem("Efficiency").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];        
            
    //         let formulasEfficiency = [];
    //         for(let i=0; i<numRows; i++) {
    //           formulasEfficiency.push([`=IFERROR(([@[Billed Hours]]/[@[Clocked Hours]]), 0)"]);`]);
    //         }
    //         resultTbl.columns.getItem("Efficiency").getDataBodyRange().formulas = formulasEfficiency;

    //         break;
    //     };
    //     await context.sync();

    //     await formatStandardRadarReport(context, ws, [resultTbl], C.SHEET_NAME_DAILY_SALES, reportDesc, C.COLOR_HEADER_DAILY_SALES, C.COLOR_HEADER_FONT_DAILY_SALES, "#FFFFFF", C.COLOR_HARLEY_BLACK, `A1:${TBL_START_CELL}`, [4]);
    //   }
      
      
    //   // Taskpane loaded report info    
    //   document.getElementById("dsu-loaded-date").textContent = `Date: ${inputDate}`;
    //   document.getElementById("dsu-loaded-store").textContent = `Store: ${inputStore}`;
    //   document.getElementById("dsu-loaded-dept").textContent = `Department: ${inputDept}`;

    //   document.getElementById("dsu-current-inputs").style.display = "grid"; // Reveal the report status div which contains the save button and last updated info
      
    //   // resultTbl.getDataBodyRange().numberFormat = [[projFieldNumFormat]]; // Set the number format for all data body columns to the appropriate format for the projected field
    //   updateFooterStatus(`${new Date().toLocaleTimeString()} - Daily Sales Leaderboard loaded successfully`);
    // }
    // else {
    //   updateFooterStatus(`${new Date().toLocaleTimeString()} - Failed to load Daily Sales Leaderboard.`);
    // }

    // ws.activate(); // Show the results
    // ws.getRange(TBL_START_CELL).select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring

    // await context.sync();
  });
}


async function loadDailySalesLeaderboard() { 
  await Excel.run(async (context) => {
    let ROW_HEADER_TABLE = 4;
    let TBL_START_CELL_HEADERS = `B${ROW_HEADER_TABLE}`;
    
    await clearSheet(context, C.SHEET_NAME_LEADERBOARD);
        
    const ws = context.workbook.worksheets.getItem(C.SHEET_NAME_LEADERBOARD);
    
    const inputDateStart = document.getElementById("dsl-date-start").value;
    const inputDateEnd = document.getElementById("dsl-date-end").value;
    const inputDept = document.getElementById("dsl-dept").value;
    const reportDesc = `Showing ${inputDept} Daily Sales Leaderboard between ${inputDateStart} and ${inputDateEnd}`;
    
    let inputBody =  JSON.stringify({
        uid : connectionInfo.uid
      , inputDateStart : inputDateStart
      , inputDateEnd : inputDateEnd
      , inputDept : inputDept
    });
    let resultHeaders = await queryStandardRadarReport('getDailySalesLeaderboardHeaders', inputBody, C.SHEET_NAME_LEADERBOARD, TBL_START_CELL_HEADERS)

    let resultTblHeaders = null;
    // if(resultHeaders.status == 'success' || true) { // temp while figuring out why queryStandard isn't returning the status properly
    if( true) {
      try {
        resultTblHeaders = ws.tables.getItemAt(0); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name
      } catch (error) {
        console.error("Error getting the result table:", error);
      }
    }
    resultTblHeaders.rows.load("count");
    await context.sync();    
    
    let ROW_ROSTER_TABLE = ROW_HEADER_TABLE + resultTblHeaders.rows.count + 3; // calculate the starting row for the roster table based on the number of rows in the header table, plus some padding
    let TBL_START_CELL = `B${ROW_ROSTER_TABLE}`; 
    
    let resultBody = await queryStandardRadarReport('getDailySalesLeaderboard', inputBody, C.SHEET_NAME_LEADERBOARD, TBL_START_CELL)
    
    // if(resultBody.status == 'success' || true) {
    if( true) { // TODO temp while debugging why queryStandard isn't returning the status properly
      let resultTbl = null;
      try {
        resultTbl = ws.tables.getItemAt(1); // the report should be the only table on the sheet, so we can just get item at 0 without needing to know its name
      } catch (error) {
        console.error("Error getting the result table:", error);
      
      }

      if( resultTbl == null) {
      }
      else{
      
        await context.sync();
        //Number formats and formulas
        const rowCount = resultTbl.rows.getCount();  
      
        
        await context.sync();
        let numRows = rowCount.value;
        let headers_tbl_curr_formats = [];
        let headers_tbl_percent_formats = [];
        
        // Add number formats to both the header and roster tables
        switch (inputDept) {
          case "General Merchandise": //these 3 departments share the same fields so they can be grouped together like this. Mind the 'break'.
          case "Parts OTC":
          case "Online":
            resultTbl.columns.getItem("Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("GP").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Margin").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
            
            headers_tbl_curr_formats = [
                "Total Sales", "PY Total Sales", "Assigned Sales", "PY Assigned Sales", "Unassigned Sales", "PY Unassigned Sales"
            ]

            for (let i=0; i<headers_tbl_curr_formats.length; i++) {
              if(resultTblHeaders.columns.getItemOrNullObject(headers_tbl_curr_formats[i]) !== null) {
                resultTblHeaders.columns.getItem(headers_tbl_curr_formats[i]).getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
              }
            };

            break;

          case "Service":        
            resultTbl.columns.getItem("Labor Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Parts to WO Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
            resultTbl.columns.getItem("Parts to Labor").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
            resultTbl.columns.getItem("Total Sales").getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];

            headers_tbl_curr_formats = [
                'Total Labor Sales', 'PY Total Labor Sales'
              , 'Total Parts to WO Sales', 'PY Total Parts to WO Sales'
              , 'Assigned Labor Sales', 'PY Assigned Labor Sales'
              , 'Assigned Parts to WO Sales', 'PY Assigned Parts to WO Sales'
              , 'Unassigned Labor Sales', 'PY Unassigned Labor Sales'
              , 'Unassigned Parts to WO Sales', 'PY Unassigned Parts to WO Sales'
            ]

            for (let i=0; i<headers_tbl_curr_formats.length; i++) {
              if(resultTblHeaders.columns.getItemOrNullObject(headers_tbl_curr_formats[i]) !== null) {
                resultTblHeaders.columns.getItem(headers_tbl_curr_formats[i]).getDataBodyRange().numberFormat = [[C.CURRENCY_FORMAT]];
              }
            };
                        
            break;

          case "Technician":
            resultTbl.columns.getItem("Efficiency").getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];        
            
            headers_tbl_percent_formats = ['Total Efficiency', 'PY Total Efficiency'
              , 'Assigned Efficiency', 'PY Assigned Efficiency'
              , 'Unassigned Efficiency', 'PY Unassigned Efficiency'
            ]

            for (let i=0; i<headers_tbl_percent_formats.length; i++) {
              if(resultTblHeaders.columns.getItemOrNullObject(headers_tbl_percent_formats[i]) !== null) {
                resultTblHeaders.columns.getItem(headers_tbl_percent_formats[i]).getDataBodyRange().numberFormat = [[C.PERCENT_FORMAT]];
              }
            };
            
            break;
        };
        
        resultTbl.columns.getItem("ID").getRange().format.horizontalAlignment = "Center"; // getRange inclues header
        resultTbl.columns.getItem("Store").getRange().format.horizontalAlignment = "Center"; // getRange inclues header

        resultTblHeaders.columns.getItem("Store").getRange().format.horizontalAlignment = "Center"; // getRange inclues header

        // // Add conditional formats to the header table
        // const conditionalFormat = resultTbl.getDataBodyRange().conditionalFormats.add(
        //     Excel.ConditionalFormatType.custom
        // );
        // conditionalFormat.custom.rule.formula = '=IF($X5>0,TRUE)'; // TODO magic number
        // conditionalFormat.custom.format.fill.color = C.COLOR_COND_FORMAT_ATTENTION;


        await context.sync();

        await formatStandardRadarReport(context, ws, [resultTbl, resultTblHeaders], C.SHEET_NAME_LEADERBOARD, reportDesc, C.COLOR_HEADER_LEADERBOARD, C.COLOR_HEADER_FONT_LEADERBOARD, "#FFFFFF", C.COLOR_HARLEY_BLACK, `1:${ROW_ROSTER_TABLE}`, [ROW_HEADER_TABLE, ROW_ROSTER_TABLE]); 
      }
      
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Sales Leaderboard Report loaded successfully`);
    }
    else {
      updateFooterStatus(`${new Date().toLocaleTimeString()} - Failed to load Sales Leaderboard Report.`);
    }

    ws.activate(); // Show the results
    ws.getRange(TBL_START_CELL).select(); // Select the first cell of data to avoid having the header row selected which can be visually jarring

    await context.sync();
  });
}

 